// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T16:59:42.266Z
// Property: Reserves at Arlington (ID: 6767906449166341)
// Collections: 27 amenities, 6 floorplans (live), 33 photos, 80 POIs, 2 reviews, 3 virtual tours, 6 office hours, 5 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166341",
  "property_external_id": "30932",
  "property_zillow_url": "https://www.zillow.com/apartments/columbus-oh/reserves-at-arlington/5Xt4Fg/",
  "property_apartments_url": "https://www.apartments.com/reserves-at-arlington-columbus-oh/1z3ktj7/",
  "property_google_business_url": "https://www.google.com/maps/place/Reserves+at+Arlington+Apartment+Homes/data=!4m2!3m1!1s0x0:0x4c757c6349670a59?sa=X&ved=2ahUKEwi72byt3riSAxUy3skDHYRSAWgQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52980254240",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "reserves-at-arlington",
  "property_name": "Reserves at Arlington",
  "property_website_url": "https://www.reservesatarlington.com/",
  "property_domain": "https://www.reservesatarlington.com/",
  "property_address": "4450 Mobile Drive",
  "property_full_address": "4450 Mobile Dr, Columbus, OH 43220",
  "property_address_1": "4450 Mobile Dr",
  "property_address_2": null,
  "property_address_city": "Columbus",
  "property_address_state": "OH",
  "property_address_zip_full": "43220-3764",
  "property_address_zip": "43220",
  "property_address_country": "US",
  "property_address_county": "Franklin County",
  "property_neighborhood_address": "Northwest",
  "property_address_latitude": "40.04959849999999",
  "property_address_longitude": "-83.04587070000001",
  "property_email": "springhouse@aionmanagement.com",
  "property_phone": "(610) 867-7100",
  "property_call_tracking_phone": "844-824-6859",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Reserves at Arlington in Columbus, OH, find your ideal living space with one and two-bedroom floor plans. Enjoy scenic walking trails, modern amenities, and pet-friendly options. With upgraded kitchens and inviting community features like grilling stations and a hot tub, your perfect retreat awaits—schedule a tour today!",
  "property_long_description": "Welcome to the Reserves at Arlington, where modern living meets serene surroundings in the heart of Columbus, OH. Our vibrant apartment community offers a diverse selection of one and two-bedroom floor plans designed to accommodate your lifestyle. Each spacious unit features stylish upgrades, including granite countertops, stainless steel appliances, and luxurious vaulted ceilings that create an airy atmosphere.\n\nLife at the Reserves at Arlington is made easy with a range of fantastic amenities. Enjoy the convenience of online rent payments via our resident portal, and rest easy knowing our dedicated on-site management team and 24-hour emergency maintenance are always available to assist you. Our pet-friendly community encourages you to bring your four-legged family members along! Take a leisurely walk along our scenic walking and biking trails, or fire up the grill at one of our outdoor grilling stations while enjoying beautiful views of the pond or ravine.\n\nWith flexible lease options, including short-term leases, you can find the perfect fit for your needs. Select from various available units that offer delightful features like private balconies, spacious kitchens with pantries, and cozy fireplaces for a truly inviting home experience. Stay connected with high-speed internet access and enjoy hassle-free parking with off-street and garage options.\n\nDon’t miss the opportunity to become a part of our lively community at the Reserves at Arlington. Find your new home today—browse our availability or schedule a tour to visit our community! Experience the perfect blend of comfort, luxury, and convenience. ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd912-a96b-7018-825b-518632ac8a9c.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019fd912-a96b-7018-825b-518632ac8a9c",
    "storage_key": "property/6767906449166341/019fd912-a96b-7018-825b-518632ac8a9c.webp",
    "width": 1493,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "34",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $300 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://reservesatarlington.loftliving.com/login",
  "property_apply_now_url": "https://www.reservesatarlington.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-af64-719c-9d68-8b2a39111ea3.webp",
  "property_primary_logo_media": {
    "alt_text": "Reserves at Arlington logo",
    "public_id": "019d026c-af64-719c-9d68-8b2a39111ea3",
    "storage_key": "property/6767906449166341/019d026c-af64-719c-9d68-8b2a39111ea3.webp",
    "width": 300,
    "height": 125
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-a579-772f-9a2f-efa0f3012a43.webp",
  "property_secondary_logo_media": {
    "alt_text": "AIon Management logo",
    "public_id": "019d026c-a579-772f-9a2f-efa0f3012a43",
    "storage_key": "property/6767906449166341/019d026c-a579-772f-9a2f-efa0f3012a43.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-ba08-75ba-b236-76e9e67101f9.webp",
  "property_icon_media": {
    "alt_text": "Regency logo",
    "public_id": "019d026c-ba08-75ba-b236-76e9e67101f9",
    "storage_key": "property/6767906449166341/019d026c-ba08-75ba-b236-76e9e67101f9.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-c75d-750d-b332-375e0e3ea81e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Reserves at Arlington logo.",
    "public_id": "019d026c-c75d-750d-b332-375e0e3ea81e",
    "storage_key": "property/6767906449166341/019d026c-c75d-750d-b332-375e0e3ea81e.webp",
    "width": 300,
    "height": 125
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-d476-72db-801b-87eab31e433b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Reserves at Arlington logo",
    "public_id": "019d026c-d476-72db-801b-87eab31e433b",
    "storage_key": "property/6767906449166341/019d026c-d476-72db-801b-87eab31e433b.webp",
    "width": 300,
    "height": 125
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1584 - 2964",
  "property_sqft_min": "1584",
  "property_sqft_max": "2964",
  "property_price_range": "2728 - 3564",
  "property_price_min": "2728",
  "property_price_max": "3564",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/reservesatarlington/",
  "property_instagram_url": "https://www.instagram.com/reservesatarlington",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2c5Q6K-NOIgRWQpnSWN8dUw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=China+Buffet&find_loc=Columbus%2C+OH",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Reserves at Arlington",
  "property_home_romance_title": "Embrace Your Dream Life at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Reserves at Arlington in Columbus, OH, where every single detail enhances your living experience. Choose from one or two-bedroom floor plans, each featuring modern kitchens and inviting spaces. Embrace an active lifestyle with our scenic trails, relaxing courtyards, and pet-friendly atmosphere. Comfort and convenience await you!",
  "property_home_floorplans_blurb": "Welcome to Reserves at Arlington in vibrant Columbus, OH, where modern living meets comfort. Choose from our thoughtfully designed one and two-bedroom floor plans that elevate your lifestyle. Each apartment home is crafted for convenience and style—ready for you to call it your own. Browse our available options today!",
  "property_home_gallery_blurb": "At Reserves at Arlington in Columbus, OH, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, complete with modern amenities like stainless steel appliances and vaulted ceilings. Enjoy scenic walking trails, pet-friendly spaces, and the luxury of 24-hour emergency maintenance. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to the Reserves at Arlington, where convenience meets comfort in Columbus, OH. Enjoy access to top-rated schools, serene parks, and vibrant cultural destinations like the Wexner Center for the Arts and the Columbus Museum of Art. Your perfect home awaits amidst a lively community brimming with local favorites!",
  "property_home_reviews_blurb": "At Reserves at Arlington in Columbus, OH, residents praise our vibrant community and attentive maintenance, with one delighted tenant stating, “Lauren is the best. She made the process easy.” Join us and experience an inviting atmosphere where comfort meets convenience. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Reserves at Arlington, Columbus comes alive right outside your door. Enjoy cultural experiences at the Wexner Center for the Arts, or catch a film at the nearby Grandview Theater. With top schools and parks like Thompson Park nearby, your vibrant lifestyle is complemented by convenience and community spirit.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Elevate your lifestyle at Reserves at Arlington, where modern comforts meet nature's beauty in Columbus, OH. Enjoy spacious one and two-bedroom floor plans, high-speed internet, and inviting grilling stations. Dive into a community that embraces pets, offers flex rent payments, and ensures your peace of mind with 24-hour emergency maintenance.",
  "property_applynow_blurb": "Experience modern living at Reserves at Arlington in Columbus, OH. Choose from thoughtfully designed one- and two-bedroom floor plans with stylish amenities, including pet-friendly spaces, scenic walking trails, and sleek kitchens with stainless steel appliances. Embrace comfort and convenience—your ideal home awaits, just a click away!",
  "property_contactus_blurb": "At Reserves at Arlington in vibrant Columbus, OH, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Embrace modern living with spacious layouts and stylish finishes. Curious to learn more or have questions? Reach out to our friendly leasing team today—your dream home awaits!",
  "property_faqs_blurb": "At Reserves at Arlington in Columbus, OH, our apartment community offers thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. From spacious interiors to convenient amenities, we have it all. Have questions? Visit our FAQs page for insights into our vibrant community and features!",
  "property_floorplans_blurb": "At Reserves at Arlington in Columbus, OH, we offer thoughtfully designed one and two-bedroom apartments tailored for your lifestyle. Each floor plan boasts stylish spaces and modern amenities to elevate your living experience. Browse our available options and find the perfect home to fit your unique needs.",
  "property_gallery_blurb": "At Reserves at Arlington, vibrant living meets serene spaces in Columbus, OH. Picture yourself unwinding in our pet-friendly community, complete with walking trails, upgraded kitchens featuring stainless steel appliances, and inviting courtyards. Experience comfort and convenience with flexible rent options and 24-hour maintenance. Your dream home awaits!",
  "property_interactivemap_blurb": "Experience the charm of Reserves at Arlington in Columbus, OH, where modern living meets nature. With one and two-bedroom options, enjoy upgraded kitchens, scenic views, and pet-friendly amenities. Dive into our interactive community map to find your perfect space, complete with walking trails and cozy grilling stations!",
  "property_pets_blurb": "At Reserves at Arlington in Columbus, OH, furry friends are part of the family! With a spacious pet-friendly policy allowing two pets up to 100 lbs, your companions can enjoy life by your side. Embrace comfortable living with nature trails and pet-friendly amenities right at your doorstep.",
  "property_referafriend_blurb": "At Reserves at Arlington in Columbus, OH, we believe that great friends make great neighbors. With a variety of one and two-bedroom floor plans, you’ll find the perfect layout to welcome your pals into your vibrant new home. Share the joy—refer a friend to our community today!",
  "property_residentaccess_blurb": "At Reserves at Arlington in Columbus, OH, our variety of thoughtfully designed one and two-bedroom floor plans offer the perfect canvas for your lifestyle. Access your resident portal today for convenient online rent payments, hassle-free maintenance scheduling, and more—your seamless living experience awaits!",
  "property_reviews_blurb": "At the Reserves at Arlington in Columbus, OH, residents appreciate the attentive maintenance and clean hallways. One resident noted, \"Lauren is the best. She made the process easy,\" highlighting our dedicated team. Join a community where comfort meets convenience—see what our residents have to say about living here!",
  "property_created_at": "1757011351841",
  "property_scheduletour_blurb": "At Reserves at Arlington in Columbus, OH, you'll find thoughtfully designed one and two-bedroom apartments that cater to your lifestyle. Each space blends comfort and style, perfect for making lasting memories. Schedule a tour today and hear firsthand from our residents why they love calling this community home!",
  "property_thankyou_blurb": "Thank you for reaching out to Reserves at Arlington in Columbus, OH! Whether you’re drawn to our cozy one-bedroom retreat or spacious two-bedroom haven, we offer floor plans designed to fit your lifestyle. A team member will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "At Reserves at Arlington in Columbus, OH, choose from thoughtfully designed one and two-bedroom apartments tailored to your lifestyle. Experience modern living with spacious floor plans and elegant finishes. Ready to see your new home? Take a virtual tour today and feel the vibrant community atmosphere!",
  "property_copyright": "2025 All Rights Reserved. Reserves at Arlington",
  "property_seo_title_home": "Northwest Columbus Apartments | Reserves at Arlington",
  "property_seo_description_home": "Reserves at Arlington apartment homes in Northwest Columbus offer 1 and 2 bedroom layouts, a pool, dog park and renovated kitchens near Upper Arlington.",
  "property_seo_title_floorplans": "1 & 2 Bedroom Apartments in Columbus, OH 43220",
  "property_seo_description_floorplans": "Compare 1 and 2 bedroom floor plans at Reserves at Arlington, with renovated kitchens, breakfast bars, roomy closets and hardwood floors or plush carpet.",
  "property_seo_title_amenities": "Pool, Dog Park & Basketball | Reserves at Arlington Apts",
  "property_seo_description_amenities": "Swim off the sundeck, shoot hoops or let the dog run. Reserves at Arlington is a pet friendly Columbus community with grilling stations and a lounge.",
  "property_seo_title_gallery": "Photos | Reserves at Arlington in Columbus, OH",
  "property_seo_description_gallery": "See renovated kitchens, tiled backsplashes and the pool with sundeck at Reserves at Arlington, then come see our Northwest Columbus apartments in person.",
  "property_seo_title_virtualtours": "Virtual Tour Apartments in Columbus | Reserves at Arlington",
  "property_seo_description_virtualtours": "Can't make it to Mobile Dr yet? Walk through Reserves at Arlington online and preview 1 and 2 bedroom apartments, the pool and dog park from your phone.",
  "property_seo_title_interactivemap": "Interactive Map | Reserves at Arlington Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal home at Reserves at Arlington in Columbus, OH! Use our interactive map to find available 1- and 2-bedroom apartments with top amenities!",
  "property_seo_title_neighborhood": "Apartments Near Upper Arlington | Reserves at Arlington",
  "property_seo_description_neighborhood": "Reserves at Arlington is minutes from Ohio State, near shopping along Bethel Rd and Henderson Rd, and close to Thompson Park and Reed Road Park.",
  "property_seo_title_contact": "Contact Reserves at Arlington | 4450 Mobile Dr",
  "property_seo_description_contact": "Contact Reserves at Arlington at 4450 Mobile Dr, Columbus, OH 43220. Call 844-824-6859 or message our leasing team about apartments for rent in Columbus.",
  "property_seo_title_faqs": "FAQs | Apartments in Columbus, OH",
  "property_seo_description_faqs": "Get answers to your burning questions at Reserves at Arlington in Columbus, OH! Learn about our pet-friendly community, amenities, and flexible rentals!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Columbus, OH",
  "property_seo_description_reviews": "Discover Reserves at Arlington in Columbus, OH! Residents love our spacious layouts, pet-friendly amenities, and vibrant community life.",
  "property_seo_title_applynow": "Apply for a Columbus Apartment | Reserves at Arlington",
  "property_seo_description_applynow": "Found your 1 or 2 bedroom apartment at Reserves at Arlington? Fill out the online rental application in a few minutes and get one step closer to move-in.",
  "property_seo_title_residentaccess": "Resident Access | Reserves at Arlington",
  "property_seo_description_residentaccess": "Reserves at Arlington residents can pay rent online, submit a maintenance request or update account details any time, without a trip to the leasing office.",
  "property_seo_title_referafriend": "Refer A Friend | Reserves at Arlington",
  "property_seo_description_referafriend": "Refer a friend to Reserves at Arlington, Columbus, OH! Share your love for our community and unlock exclusive rewards today!",
  "property_seo_title_scheduletour": "Tour Reserves at Arlington | Northwest Columbus, OH",
  "property_seo_description_scheduletour": "Pick a time to visit Reserves at Arlington on Mobile Dr. Walk through a 1 or 2 bedroom apartment, see the pool and dog park and ask our team about leasing.",
  "property_seo_title_privacy": "Privacy Policy | Reserves at Arlington",
  "property_seo_description_privacy": "Learn what information Reserves at Arlington collects through this website, how it is used and the steps we take to keep your personal details protected.",
  "property_seo_title_accessibility": "Accessibility | Reserves at Arlington",
  "property_seo_description_accessibility": "Reserves at Arlington wants this website to work for everyone. Read about our accessibility efforts and how to reach us if part of the site is hard to use.",
  "property_seo_title_sitemap": "Sitemap | Reserves at Arlington",
  "property_seo_description_sitemap": "Use the Reserves at Arlington sitemap to jump straight to floor plans, amenities, photos, neighborhood details, tour scheduling and the online application.",
  "property_seo_title_thankyou": "Thank You | Reserves at Arlington",
  "property_seo_description_thankyou": "Thank you for reaching out to Reserves at Arlington! Our team in Columbus, OH, will connect soon to assist you in finding your ideal home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Columbus, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793637725405",
  "amenities": [
    {
      "id": "custom_23f21351-cff2-4c62-9cb9-3f6cf45101f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e23b5870-f991-4053-93ee-0b064bbb3f4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled-Access Buildings",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d786c9ed-4663-4077-86c5-75c531b9edea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9bea8a49-83d7-4adf-9975-8812b72a422c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2376ff7c-b1db-4bdd-8702-3c6cef8d609f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76ceca43-ef0f-4fa6-9dfd-1d9f99e03cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63cbbf19-79d6-4b22-a86a-1c3f1652e878",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57c5eb24-8c56-4bb7-8685-cc877bde7815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leasing",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_132cfcd3-30e5-4034-b710-9de47ea87133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1956d31a-34ad-40d4-a2c5-c80890660108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Ample Closet Space",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45966da5-4fc8-4e84-a81e-bc00f51f058c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c4f8e65-ccf8-4242-a524-8e386393eed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b10a642f-f5ce-41cf-bf38-6c46d545d8ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48053548-d739-4c7e-add3-b2b3c38c3edf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43b9bcfb-5a1b-4eaa-8635-8810cd96b1bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a388cb3e-a299-4a70-a5a5-692a2b733aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens & Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c32546d-cd7f-4e2a-aad4-16163df445b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61bfef02-bc31-4377-9354-82dd52a39e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Tiled Backsplash",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6afa92a6-b5c8-4c27-aab6-827e1e19da58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Less than 3 Miles to OSU",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd46b386-8655-4841-b342-29227d88f490",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Shopping, Dining & Entertainment Along Bethel & Henderson Rd.",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3337e7a-1eb9-4ef4-a4b4-2d176ff33f39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Short Walk to Bus Line",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_046600fa-d354-4ecd-b611-33940e41c670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06b20893-c966-427b-aef0-a64feaeeddbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c1e0ad4-15ec-4e78-a9b6-1803e10ebcb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Stations/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3edbc566-788e-4ab6-b5a8-716d78ee0d93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_222715f3-c92b-4e3b-af2c-c2eaab490b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca6d59ea-8d08-485c-8f22-2e5f861d5369",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b5efc905-d4d3-4cea-895a-64772c4a8710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b143-77ef-b401-bf89a8a00466.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, white cabinets, granite countertops, and a dishwasher.",
        "public_id": "019fd92c-b143-77ef-b401-bf89a8a00466",
        "storage_key": "property/6767906449166341/019fd92c-b143-77ef-b401-bf89a8a00466.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Discover your dream kitchen featuring sleek stainless steel appliances, ample white cabinetry, and elegant granite countertops.",
      "link": "false",
      "alt_text": "modern kitchen with white cabinets, stainless appliances, and a stainless fridge and stove. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-12-1920w.jpg"
    },
    {
      "id": "custom_2d4455d3-e516-4294-b373-8fd861efe808",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b18f-73cb-8d4f-0175936e31ca.webp",
      "image_media": {
        "alt_text": "Spacious living room with beige sofa, coffee table, and dining area.",
        "public_id": "019fd92c-b18f-73cb-8d4f-0175936e31ca",
        "storage_key": "property/6767906449166341/019fd92c-b18f-73cb-8d4f-0175936e31ca.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Enjoy a comfortable and stylish living space with ample room for relaxation and dining.",
      "link": "false",
      "alt_text": "Bright living room with beige sofa, coffee table, rug, and small dining area opening to a kitchen. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-13_07-07-26_13_27-1920w.jpeg"
    },
    {
      "id": "custom_f574bd4d-9bef-417d-bd7f-33e2766da3d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b1be-73ce-94ab-deb9396edd4f.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, double sink, and dishwasher.",
        "public_id": "019fd92c-b1be-73ce-94ab-deb9396edd4f",
        "storage_key": "property/6767906449166341/019fd92c-b1be-73ce-94ab-deb9396edd4f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a double sink, and stainless steel appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "kitchen with white cabinets, black dishwasher, and view into a carpeted living room. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-18_07-07-26_12_40-1920w.jpeg"
    },
    {
      "id": "custom_37f8ef71-ba8e-4e2b-99d7-befce9bc6be9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b16e-7399-aba9-28055a1f2e6b.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, coffee table, and small dining set.",
        "public_id": "019fd92c-b16e-7399-aba9-28055a1f2e6b",
        "storage_key": "property/6767906449166341/019fd92c-b16e-7399-aba9-28055a1f2e6b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "A cozy living and dining area with a comfortable sofa, a glass-top coffee table, and a compact dining set perfect for two. The open kitchen view adds to the spacious feel.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, dining nook, beige carpet, and wall art. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-19_07-07-26_12_39-1920w.jpeg"
    },
    {
      "id": "custom_44147b3c-3c63-432a-9745-1a69e8f3aab6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-bc90-7176-beb6-fd62b490ac42.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and bar seating.",
        "public_id": "019fd92c-bc90-7176-beb6-fd62b490ac42",
        "storage_key": "property/6767906449166341/019fd92c-bc90-7176-beb6-fd62b490ac42.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable sectional sofa, modern coffee table, and convenient bar seating with stools. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Modern living room with gray sectional, coffee table, rug, lamps, and ceiling fan; kitchen bar nearby at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-09_07-07-26_12_45-1920w.jpeg"
    },
    {
      "id": "custom_3e1c0f28-1b90-4eea-ab3d-c5a5dd3709d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-bcfa-72d4-9ddb-66bcfe246c91.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, lamp, closet, and artwork on the wall.",
        "public_id": "019fd92c-bcfa-72d4-9ddb-66bcfe246c91",
        "storage_key": "property/6767906449166341/019fd92c-bcfa-72d4-9ddb-66bcfe246c91.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, decorative artwork, and ample closet space for your storage needs.",
      "link": "false",
      "alt_text": "Bright bedroom with a bed, wall art, open closet, and carpeted floor at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-10_07-07-26_12_37-1920w.jpeg"
    },
    {
      "id": "custom_0391171d-36b4-4d40-b2ef-ff30c71e3122",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-bdf8-7470-897c-cd9652fc4a56.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstand, closet, and artwork.",
        "public_id": "019fd92c-bdf8-7470-897c-cd9652fc4a56",
        "storage_key": "property/6767906449166341/019fd92c-bdf8-7470-897c-cd9652fc4a56.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, ample closet space, and stylish decor. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bright bedroom with gray walls, bed, open closet, and hallway view at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-20_07-07-26_12_35-1920w.jpeg"
    },
    {
      "id": "custom_2dddfd6e-f570-4d0f-b7d6-1f72f8b91e0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-be3e-73f9-92da-542acbcf355f.webp",
      "image_media": {
        "alt_text": "Desk with laptop and chair in a home office with a window and plants.",
        "public_id": "019fd92c-be3e-73f9-92da-542acbcf355f",
        "storage_key": "property/6767906449166341/019fd92c-be3e-73f9-92da-542acbcf355f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Create your ideal home office setup with this spacious desk, comfortable chair, and elegant shelving unit. Natural light streams through the window, illuminating the space.",
      "link": "false",
      "alt_text": "bedroom staged as home office with wood desk, computer, chair, plant, window, and wall art. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves_at_Arlington-POI-14_07-07-26_13_07-1920w.jpeg"
    },
    {
      "id": "custom_a69e46d4-deff-4e6e-a7f9-4fe7be77f238",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-cb40-73fb-af9f-b98b263f6b34.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black faucet, and toilet.",
        "public_id": "019fd92c-cb40-73fb-af9f-b98b263f6b34",
        "storage_key": "property/6767906449166341/019fd92c-cb40-73fb-af9f-b98b263f6b34.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a sleek white vanity, modern black fixtures, and a clean, inviting atmosphere.",
      "link": "false",
      "alt_text": "White bathroom with vanity, mirror, toilet, and tub with gray shower curtain and towels at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-15-1920w.jpg"
    },
    {
      "id": "custom_c25f6309-da86-471c-8cd1-4d3d0a1c95df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-cb37-7502-9553-2471fc952eca.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a laundry closet",
        "public_id": "019fd92c-cb37-7502-9553-2471fc952eca",
        "storage_key": "property/6767906449166341/019fd92c-cb37-7502-9553-2471fc952eca.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "Stacked washer and dryer in a narrow laundry closet with a partially open door at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-11-1920w.jpg"
    },
    {
      "id": "custom_0d9bac86-53dc-4429-b157-e9c796c3669a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-cb36-727a-9db2-711a852fede8.webp",
      "image_media": {
        "alt_text": "Empty linen closet with white shelves and a black door handle.",
        "public_id": "019fd92c-cb36-727a-9db2-711a852fede8",
        "storage_key": "property/6767906449166341/019fd92c-cb36-727a-9db2-711a852fede8.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Maximize your storage space with this spacious linen closet, featuring multiple shelves for organization.",
      "link": "false",
      "alt_text": "Open linen closet with white shelves beside a bathroom vanity and mirror. at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-16-1920w.jpg"
    },
    {
      "id": "custom_877c416f-bb32-4344-a295-ea023b93ec35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-cba7-764a-b2fe-13ac426595ca.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a black faucet.",
        "public_id": "019fd92c-cba7-764a-b2fe-13ac426595ca",
        "storage_key": "property/6767906449166341/019fd92c-cba7-764a-b2fe-13ac426595ca.webp",
        "width": 1240,
        "height": 828
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright white apartment kitchen with granite counters and stainless steel appliances at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/340dcbf9549fe14909225c0c855142ed-1920w.webp"
    },
    {
      "id": "custom_d5f971de-35a0-43c1-a311-13ff3133683e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-d4e7-7690-91b8-e33c81842617.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, light-colored cabinets, and mosaic tile backsplash.",
        "public_id": "019fd92c-d4e7-7690-91b8-e33c81842617",
        "storage_key": "property/6767906449166341/019fd92c-d4e7-7690-91b8-e33c81842617.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances including a refrigerator, dishwasher, and oven. Ample cabinet space and a mosaic tile backsplash provide both style and function.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, light-colored cabinets, and mosaic tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-08-1920w.jpg"
    },
    {
      "id": "custom_a01f4f9d-a74f-419c-a134-c3a29961f7f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-d4d5-7409-bad2-36febae83f7e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, tiled backsplash, stainless steel sink, and white appliances.",
        "public_id": "019fd92c-d4d5-7409-bad2-36febae83f7e",
        "storage_key": "property/6767906449166341/019fd92c-d4d5-7409-bad2-36febae83f7e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white cabinets, a mosaic tile backsplash, and full-size appliances including refrigerator, dishwasher, and stove.",
      "link": "false",
      "alt_text": "Kitchen in an apartment with white cabinets, fridge, dishwasher, stove, and a mosaic backsplash at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/37c3bbb03e142d76c1b6917de1aa91e5-1920w.jpg"
    },
    {
      "id": "custom_406f27ab-4111-4270-8dc2-90df4cb75878",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-d665-75f7-8868-da4db65ec970.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019fd92c-d665-75f7-8868-da4db65ec970",
        "storage_key": "property/6767906449166341/019fd92c-d665-75f7-8868-da4db65ec970.webp",
        "width": 1240,
        "height": 828
      },
      "title": "Apartment",
      "description": "Bright, modern living area with neutral furnishings, open kitchen, and a wall-mounted TV—showcasing an inviting apartment interior.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, round coffee table, and a wall-mounted TV; open kitchen in back at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/0ae07955dc507cc1702fb74ee6958bcd-1920w.webp"
    },
    {
      "id": "custom_10c517be-ea8d-4c3f-aaa8-d1b439cbbd10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-d728-7757-b3ce-4960d9b89a12.webp",
      "image_media": {
        "alt_text": "Living room with a large TV, modern media console, coffee table, and sofa.",
        "public_id": "019fd92c-d728-7757-b3ce-4960d9b89a12",
        "storage_key": "property/6767906449166341/019fd92c-d728-7757-b3ce-4960d9b89a12.webp",
        "width": 1240,
        "height": 828
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Apartment living room with gray sofa, round coffee table, TV, window, and framed art at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/dce742ee066e3873b0b7e2cfaf9ca132-1920w.webp"
    },
    {
      "id": "custom_29a4f1c3-b389-466a-a71b-cfbba60f30d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-e032-7009-925f-d1b459dd37a4.webp",
      "image_media": {
        "alt_text": "Living room with open kitchen and dining area.",
        "public_id": "019fd92c-e032-7009-925f-d1b459dd37a4",
        "storage_key": "property/6767906449166341/019fd92c-e032-7009-925f-d1b459dd37a4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Open-concept living area with modern furnishings, linking the living room to the kitchen and dining space.",
      "link": "false",
      "alt_text": "Living room in an apartment with two gray sofas and an open kitchen at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/d480ef32df6ac1933e7bd60baef27c54-1920w.jpg"
    },
    {
      "id": "custom_e2362c24-fd77-4e78-8d9d-46ab3e8355f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-e165-74ac-948c-63f24caa7c39.webp",
      "image_media": {
        "alt_text": "Dining room with a wooden table and chairs, leading to a kitchen.",
        "public_id": "019fd92c-e165-74ac-948c-63f24caa7c39",
        "storage_key": "property/6767906449166341/019fd92c-e165-74ac-948c-63f24caa7c39.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Open dining area with a wooden table and chairs, open to a modern kitchen at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/58dc7c9399db5120ff778dd55e58087e-1920w.jpg"
    },
    {
      "id": "custom_12dd725c-5929-4331-8389-f10ddc05e913",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-e108-7696-96d1-c16909e0d3b0.webp",
      "image_media": {
        "alt_text": "Clean and modern bedroom with a large TV, dresser, and a comfortable bed.",
        "public_id": "019fd92c-e108-7696-96d1-c16909e0d3b0",
        "storage_key": "property/6767906449166341/019fd92c-e108-7696-96d1-c16909e0d3b0.webp",
        "width": 1240,
        "height": 828
      },
      "title": "Apartment",
      "description": "Cozy, modern bedroom in our apartment community with neutral decor, a large TV, and natural light.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, dresser, and window at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/b8027bbb846fe2f5c01e307cafc91b87-1920w.webp"
    },
    {
      "id": "custom_7d48e03d-2f93-4def-935c-435ed07f5df2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-e27b-77bb-a58b-ab10629a97d5.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and floral bedding, two round mirrors on the wall, and a window with white curtains.",
        "public_id": "019fd92c-e27b-77bb-a58b-ab10629a97d5",
        "storage_key": "property/6767906449166341/019fd92c-e27b-77bb-a58b-ab10629a97d5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy secondary bedroom in a modern apartment with a twin bed, floral duvet, round mirrors, and bright light from sheer curtains.",
      "link": "false",
      "alt_text": "Small white bedroom with a single bed, floral duvet, round mirrors, and sheer polka-dot curtains at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/6ae4d4433a2db174bf196045aeccebdc-1920w.jpg"
    },
    {
      "id": "custom_a7993ad7-319a-444a-9e9d-d4b2880f2d2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-eb73-7761-b1ac-c36a46f09f4f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, mirror, toilet, and shower with a decorative curtain.",
        "public_id": "019fd92c-eb73-7761-b1ac-c36a46f09f4f",
        "storage_key": "property/6767906449166341/019fd92c-eb73-7761-b1ac-c36a46f09f4f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom with white fixtures and a decorative raindrop shower curtain.",
      "link": "false",
      "alt_text": "Apartment bathroom with a white vanity, sink, toilet, and shower curtain with a raindrop pattern at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/8e2ddba86f92ca8630d95aa8c32d53d9-1920w.jpg"
    },
    {
      "id": "custom_037e00bc-6fc7-4327-92a0-1639d63406ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-ebe5-74ca-ab3b-95c386b92e2f.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers.",
        "public_id": "019fd92c-ebe5-74ca-ab3b-95c386b92e2f",
        "storage_key": "property/6767906449166341/019fd92c-ebe5-74ca-ab3b-95c386b92e2f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "On-site laundry facilities with multiple washers and dryers for resident convenience.",
      "link": "false",
      "alt_text": "Bright shared laundry room with stacked washers and dryers along beige walls and wood-look flooring",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-17-1920w.jpg"
    },
    {
      "id": "custom_28a1e2e6-2181-4bb2-af59-5ff5e3588ae3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-ee53-7244-9f17-99b24b3ab3e0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019fd92c-ee53-7244-9f17-99b24b3ab3e0",
        "storage_key": "property/6767906449166341/019fd92c-ee53-7244-9f17-99b24b3ab3e0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Courtyard swimming pool with blue water, lounge chairs, and apartment buildings under a red umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-03-1920w.jpg"
    },
    {
      "id": "custom_3ea4eac7-2756-4cd5-966d-78a0acadde1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-ee8c-7169-bb2d-27a81a530581.webp",
      "image_media": {
        "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "019fd92c-ee8c-7169-bb2d-27a81a530581",
        "storage_key": "property/6767906449166341/019fd92c-ee8c-7169-bb2d-27a81a530581.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lounge chairs and lush landscaping. Perfect for relaxing on sunny days.",
      "link": "false",
      "alt_text": "Apartment courtyard with a turquoise pool, tan deck chairs, and gray two-story buildings around it",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-02-1920w.jpg"
    },
    {
      "id": "custom_cc364f64-1c5c-4ebb-bfd7-735f658f9391",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-f5b7-7080-b650-86256b12fd46.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a couch, coffee table, dining table, and umbrella outside the leasing office.",
        "public_id": "019fd92c-f5b7-7080-b650-86256b12fd46",
        "storage_key": "property/6767906449166341/019fd92c-f5b7-7080-b650-86256b12fd46.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy comfortable outdoor seating and dining options on our patio, conveniently located near the leasing office for easy access and resident services.",
      "link": "false",
      "alt_text": "Covered outdoor patio with orange cushions, table, chairs, and glass doors beside a leasing office",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-05-1920w.jpg"
    },
    {
      "id": "custom_bdfa0353-d3f0-4176-b605-f41e4534ce48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-f77a-702b-a4c2-d04297789869.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment including tunnels and hoops.",
        "public_id": "019fd92c-f77a-702b-a4c2-d04297789869",
        "storage_key": "property/6767906449166341/019fd92c-f77a-702b-a4c2-d04297789869.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community park with a fenced play area, benches, and trees.",
      "link": "false",
      "alt_text": "Outdoor dog agility course on a grassy field with hoops, a ramp, and trees in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/24bb345b444164cd645eac46d0e4a13b-1920w.jpg"
    },
    {
      "id": "custom_aa7133f9-215c-4a34-9933-d41e0f52af08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-fa40-7216-9e3a-7bc3deb34ac6.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment like a tunnel and jump, next to apartment buildings.",
        "public_id": "019fd92c-fa40-7216-9e3a-7bc3deb34ac6",
        "storage_key": "property/6767906449166341/019fd92c-fa40-7216-9e3a-7bc3deb34ac6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, featuring agility equipment for your furry friends to play and exercise. A perfect amenity for pet owners.",
      "link": "false",
      "alt_text": "Grassy fenced dog park with agility obstacles beside apartment buildings and trees under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/cb71040c1d80eb9d09b7548f090809bd-1920w.jpg"
    },
    {
      "id": "custom_1d89c6db-8cdd-4a92-8f73-602b4fe90a9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-fa30-7722-858b-fbd7156e9b4c.webp",
      "image_media": {
        "alt_text": "Kitchen island with bar stools and granite countertop",
        "public_id": "019fd92c-fa30-7722-858b-fbd7156e9b4c",
        "storage_key": "property/6767906449166341/019fd92c-fa30-7722-858b-fbd7156e9b4c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright, contemporary apartment kitchen with a stone-front island, stainless steel appliances, and three metal stools for casual dining.",
      "link": "false",
      "alt_text": "clubhouse kitchen with granite island, three pendant lights, and bar stools in a bright open layout",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/fbed0ed9a3beb409d2ba6227995066af-1920w.jpg"
    },
    {
      "id": "custom_dece57e2-c3b5-4a4c-962e-6251386c762b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-0282-722f-9518-9450507e3c9e.webp",
      "image_media": {
        "alt_text": "Dining area with a large wooden table and six metal chairs.",
        "public_id": "019fd92d-0282-722f-9518-9450507e3c9e",
        "storage_key": "property/6767906449166341/019fd92d-0282-722f-9518-9450507e3c9e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Cozy dining nook inside a modern apartment with a wood table, metal chairs, white wainscoting, and a window with blinds.",
      "link": "false",
      "alt_text": "clubhouse dining area with a wooden table, metal chairs, light blue walls, and a window with blinds at the Reserves at Arlington in Columbus, OH.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/5767906449162442/6767906449166341/5aa3b2e7d56c81d1fd0ce0346124a9b0-1920w.jpg"
    },
    {
      "id": "custom_7d1250aa-9048-4e8e-8610-3370c21f13b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-041b-731b-bc5f-95d617831705.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a fenced outdoor swimming pool, lounge chairs, umbrellas, and cornhole games on the lawn.",
        "public_id": "019fd92d-041b-731b-bc5f-95d617831705",
        "storage_key": "property/6767906449166341/019fd92d-041b-731b-bc5f-95d617831705.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by lush landscaping and ample seating. Relax and play lawn games on the expansive green lawn.",
      "link": "false",
      "alt_text": "Apartment complex pool with orange umbrellas, black fence, and green lawn under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-04-1920w.jpg"
    },
    {
      "id": "custom_8a7ee344-a021-438d-9662-027a9873d996",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-0775-73d6-a91b-1f293fabece3.webp",
      "image_media": {
        "alt_text": "Apartment complex with a fenced-in pool area surrounded by lush landscaping.",
        "public_id": "019fd92d-0775-73d6-a91b-1f293fabece3",
        "storage_key": "property/6767906449166341/019fd92d-0775-73d6-a91b-1f293fabece3.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, perfect for a sunny afternoon. Surrounded by beautiful landscaping and comfortable seating areas, it's an ideal spot to relax and unwind.",
      "link": "false",
      "alt_text": "apartment courtyard with pool, flower beds, and orange umbrellas under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-01-1920w.jpg"
    },
    {
      "id": "custom_6c767e50-299f-45e7-9f81-df12d330ceb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-093d-7438-b037-a71166f44052.webp",
      "image_media": {
        "alt_text": "Reserves at Arlington apartment building exterior with green lawn and dry creek bed.",
        "public_id": "019fd92d-093d-7438-b037-a71166f44052",
        "storage_key": "property/6767906449166341/019fd92d-093d-7438-b037-a71166f44052.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover your new home at Reserves at Arlington, featuring beautiful landscaping and a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "buildings beside landscaped lawn with curved flower bed and trees under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-07-1920w.jpg"
    },
    {
      "id": "custom_696b6c29-f71d-4733-b23c-2c4d3d5a9ae5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-116f-702a-bdc4-f929ba2f8e0d.webp",
      "image_media": {
        "alt_text": "Signage for Reserves at Arlington with phone number and website.",
        "public_id": "019fd92d-116f-702a-bdc4-f929ba2f8e0d",
        "storage_key": "property/6767906449166341/019fd92d-116f-702a-bdc4-f929ba2f8e0d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome sign for Reserves at Arlington apartment community. Includes contact phone number and website address.",
      "link": "false",
      "alt_text": "Reserves apartment community sign in front of brick buildings and a parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/d5419f44/dms3rep/multi/opt/Reserves+at+Arlington-POI-06-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5ce150bd-609b-489d-a34a-2bd4f8594c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Xi Xia Chinese Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "1140 Kenny Centre Mall, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-86e3-7743-aa0c-28cfca97041f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-86e3-7743-aa0c-28cfca97041f",
        "storage_key": "property/6767906449166341/019d026a-86e3-7743-aa0c-28cfca97041f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.xixiacuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15176481410126961552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xi-xia-chinese-cuisine",
      "poi_latitude": "40.050292",
      "poi_longitude": "-83.0510526",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-670-7736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVViYNWuNOIgRkNvvHm-xndI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_f5b6fddc-f516-465f-ae1a-bde082b1dac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Belle's Bread Japanese Bakery and Café",
      "poi_type": "Restaurants",
      "poi_address": "1168 Kenny Centre Mall, Columbus, OH 43220, USA",
      "poi_short_description": "Pastries, custom cakes & other desserts, plus a cafe menu, offered in a cheery space with seating.",
      "poi_long_description": "Pastries, custom cakes & other desserts, plus a cafe menu, offered in a cheery space with seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8714-7508-8900-48ec73be9d26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-8714-7508-8900-48ec73be9d26",
        "storage_key": "property/6767906449166341/019d026a-8714-7508-8900-48ec73be9d26.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://bellesbread.japanmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1338105226283665195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belles-bread-japanese-bakery-and-caf",
      "poi_latitude": "40.0505812",
      "poi_longitude": "-83.0517674",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 614-451-7110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ400C5KSNOIgRK0e7HJ3nkRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_01511c47-0e42-4d5c-83aa-2f56f3dcdfb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Tensuke Ramen",
      "poi_type": "Restaurants",
      "poi_address": "1155 Old Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Simple, modern noodle shop inside a Japanese market, offering udon & a few kitchen entrees.",
      "poi_long_description": "Simple, modern noodle shop inside a Japanese market, offering udon & a few kitchen entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-86fa-731e-8057-5e2233617f48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-86fa-731e-8057-5e2233617f48",
        "storage_key": "property/6767906449166341/019d026a-86fa-731e-8057-5e2233617f48.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tensukeexpress.japanmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13667674678713914084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tensuke-ramen",
      "poi_latitude": "40.0508653",
      "poi_longitude": "-83.05119069999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-451-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3KdjaSNOIgR5BJYsrRVrb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_64edc92e-cbc5-4bfb-bb02-327c7c7aae2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Akai Hana",
      "poi_type": "Restaurants",
      "poi_address": "1173 Old Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "A simple, understated setting for Japanese & Korean cuisine backed by beer, wine, soju & sake.",
      "poi_long_description": "A simple, understated setting for Japanese & Korean cuisine backed by beer, wine, soju & sake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8718-7310-ae06-43a602b51f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-8718-7310-ae06-43a602b51f89",
        "storage_key": "property/6767906449166341/019d026a-8718-7310-ae06-43a602b51f89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://akaihana.japanmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8495422204946493802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "akai-hana",
      "poi_latitude": "40.0506454",
      "poi_longitude": "-83.05174079999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-451-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3hrl6SNOIgRajHNFnzN5XU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_5b4c4b8f-c39e-417d-b30a-661558775b40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Sushi Ten",
      "poi_type": "Restaurants",
      "poi_address": "1159 Old Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Market-based sushi spot with an extensive menu of raw fish & rolls plus poke, edamame & miso soup.",
      "poi_long_description": "Market-based sushi spot with an extensive menu of raw fish & rolls plus poke, edamame & miso soup.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8e10-70b8-9f65-24971e589fde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-8e10-70b8-9f65-24971e589fde",
        "storage_key": "property/6767906449166341/019d026a-8e10-70b8-9f65-24971e589fde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sushiten.japanmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8901520638321316398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-ten",
      "poi_latitude": "40.0508253",
      "poi_longitude": "-83.0512912",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-451-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2BtvaSNOIgRLlLzt9uNiHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_b3a9645e-d189-4169-a704-b8ae2ba7405a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "ChiliSpot椒点",
      "poi_type": "Restaurants",
      "poi_address": "1178 Kenny Centre Mall, Columbus, OH 43220, USA",
      "poi_short_description": "Laid-back restaurant serving traditional Chinese cuisine amid streamlined surrounds.",
      "poi_long_description": "Laid-back restaurant serving traditional Chinese cuisine amid streamlined surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8dcd-7147-948e-92df484be54b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-8dcd-7147-948e-92df484be54b",
        "storage_key": "property/6767906449166341/019d026a-8dcd-7147-948e-92df484be54b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://chilispotusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11123087495570285284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilispot",
      "poi_latitude": "40.0502277",
      "poi_longitude": "-83.0517015",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-929-5565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZxXXOP-NOIgR5GIOAyUlXZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_70fcaa56-dde5-46c4-b6b1-62071e0bd56c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "湘遇东北 Pacific Eatery & Catering",
      "poi_type": "Restaurants",
      "poi_address": "4514 Kenny Rd #B, Columbus, OH 43220, USA",
      "poi_short_description": "Unassuming outfit serving up Chinese classics, from dumplings & egg rolls to lo mein & moo shu pork.",
      "poi_long_description": "Unassuming outfit serving up Chinese classics, from dumplings & egg rolls to lo mein & moo shu pork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-908e-70bc-b6b5-727575bcec0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-908e-70bc-b6b5-727575bcec0c",
        "storage_key": "property/6767906449166341/019d026a-908e-70bc-b6b5-727575bcec0c.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "http://pacificeateryoh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5840600858083190516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "-pacific-eatery--catering",
      "poi_latitude": "40.0511685",
      "poi_longitude": "-83.0493632",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 614-451-1428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7T4HKWNOIgR9ObjHIn7DVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_ffcd44bb-06e7-46fe-8b85-4424ad65cdc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Pho Chef",
      "poi_type": "Restaurants",
      "poi_address": "1186 Kenny Centre Mall, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-908e-70bc-b6b5-6d7ce386379c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-908e-70bc-b6b5-6d7ce386379c",
        "storage_key": "property/6767906449166341/019d026a-908e-70bc-b6b5-6d7ce386379c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://phochefbestphointown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5269474734755740503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-chef",
      "poi_latitude": "40.0500586",
      "poi_longitude": "-83.05177669999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 614-456-7616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKevT86CNOIgRV_sCNlrvIEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e145e1f7-8ea5-4dbf-a355-9e13a65b4d80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "VGET Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1157 Kenny Centre Mall, Columbus, OH 43220, USA",
      "poi_short_description": "Casual coffee shop serving comfort food, including rice rolls and milk tea.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-93f4-7019-9f87-78d2e2329f4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-93f4-7019-9f87-78d2e2329f4e",
        "storage_key": "property/6767906449166341/019d026a-93f4-7019-9f87-78d2e2329f4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vget.cafe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14662330019002712973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vget-cafe",
      "poi_latitude": "40.0495416",
      "poi_longitude": "-83.0518007",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 978-319-8583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-14df-7231-ab61-6f826959feb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-14df-7231-ab61-6f826959feb6",
        "storage_key": "property/6767906449166341/019d026b-14df-7231-ab61-6f826959feb6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHyB2WwCNOIgRjQM0yncPe8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_10906f49-f895-430f-b8a0-7362b06a50f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Donatos Pizza",
      "poi_type": "Restaurants",
      "poi_address": "4515 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Chain selling crispy pizzas featuring provolone cheese & lots of toppings, plus oven-baked subs.",
      "poi_long_description": "Chain selling crispy pizzas featuring provolone cheese & lots of toppings, plus oven-baked subs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-945f-70df-bd2a-18335e273336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-945f-70df-bd2a-18335e273336",
        "storage_key": "property/6767906449166341/019d026a-945f-70df-bd2a-18335e273336.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "https://www.donatos.com/?location=8",
      "poi_directions_map_url": "https://maps.google.com/?cid=9927080377394915140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donatos-pizza",
      "poi_latitude": "40.0512451",
      "poi_longitude": "-83.050139",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-459-9523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWho5KSNOIgRROdf3wETxIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_dc56191f-6606-400b-ae23-874c1e8c479f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "HoneyDip Donuts & Diner",
      "poi_type": "Restaurants",
      "poi_address": "4480 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Diner-like shop offering coffee and breakfast standards such as omelets and corned beef hash, plus donuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9595-749f-9e60-edf40dce3181.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-9595-749f-9e60-edf40dce3181",
        "storage_key": "property/6767906449166341/019d026a-9595-749f-9e60-edf40dce3181.webp",
        "width": 1275,
        "height": 956
      },
      "poi_business_url": "http://honeydipdonutsdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15560923015449646911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeydip-donuts--diner",
      "poi_latitude": "40.0498549",
      "poi_longitude": "-83.0493709",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 614-459-0812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_2L16SNOIgRP5cTiQmB89c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_783c7bb3-157f-4ee9-a346-624a8ff81047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Stone Bar and Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1045 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Warm restaurant, bar and sports venue, serving elevated grub such as steak salad, lobster mac, fish tacos and wings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-95c8-75ac-99bd-ccbf66f1ec0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-95c8-75ac-99bd-ccbf66f1ec0f",
        "storage_key": "property/6767906449166341/019d026a-95c8-75ac-99bd-ccbf66f1ec0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stonebarandkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4543956109153043166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-bar-and-kitchen",
      "poi_latitude": "40.0625915",
      "poi_longitude": "-83.0474857",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 614-914-5142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxgPDgCNOIgR3oIIoQFgDz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7883bd5c-0e34-4eb5-b133-af9337360571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "La Casita",
      "poi_type": "Restaurants",
      "poi_address": "1355 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Cozy cantina offering traditional Mexican favorites & margaritas plus a seasonal patio.",
      "poi_long_description": "Cozy cantina offering traditional Mexican favorites & margaritas plus a seasonal patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9a82-7273-9750-846def74ef5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-9a82-7273-9750-846def74ef5c",
        "storage_key": "property/6767906449166341/019d026a-9a82-7273-9750-846def74ef5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lacasitacolumbus2001.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=1355300504683857684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-casita",
      "poi_latitude": "40.0632777",
      "poi_longitude": "-83.0553973",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-457-0823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4KADwuNOIgRFMeW2aD-zhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7dd8e971-495d-4269-bc52-9320722ca0d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Preston Eatery",
      "poi_type": "Restaurants",
      "poi_address": "1093 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Laid-back establishment with colorful decor offering sandwiches, salads & soups, plus desserts.",
      "poi_long_description": "Laid-back establishment with colorful decor offering sandwiches, salads & soups, plus desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9a82-7273-9750-8309db0c9765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-9a82-7273-9750-8309db0c9765",
        "storage_key": "property/6767906449166341/019d026a-9a82-7273-9750-8309db0c9765.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.prestoneatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10557820681168528655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "preston-eatery",
      "poi_latitude": "40.0629925",
      "poi_longitude": "-83.0481662",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 614-867-5585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAy-28giNOIgRD6VSx_jphJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_33da056b-ead9-4543-81af-8ccc947c21f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Kelley's Pub & Patio",
      "poi_type": "Restaurants",
      "poi_address": "1940 W Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Laid-back neighborhood bar and eatery featuring a menu of Cajun classics, plus burgers and steaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9d80-74ff-8756-f156261597fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-9d80-74ff-8756-f156261597fb",
        "storage_key": "property/6767906449166341/019d026a-9d80-74ff-8756-f156261597fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/kelleysbar22",
      "poi_directions_map_url": "https://maps.google.com/?cid=6328308468535872113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelleys-pub--patio",
      "poi_latitude": "40.0564476",
      "poi_longitude": "-83.0710924",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-429-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-15cf-7558-bfdd-08d71c6d6ff9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-15cf-7558-bfdd-08d71c6d6ff9",
        "storage_key": "property/6767906449166341/019d026b-15cf-7558-bfdd-08d71c6d6ff9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmxD-N76NOIgRcUot-AWr0lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_c2be0d76-f0f1-43f5-b192-9116b70b65bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Tensuke Market, llc",
      "poi_type": "Shopping & Retail",
      "poi_address": "1167 Old Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Lively market specializing in Japanese grocery staples like sake and bento boxes, plus fresh seafood and sushi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9c75-7033-b9c6-cb0ab8e6ca51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-9c75-7033-b9c6-cb0ab8e6ca51",
        "storage_key": "property/6767906449166341/019d026a-9c75-7033-b9c6-cb0ab8e6ca51.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://tensukemarket.japanmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14425845601355491186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tensuke-market-llc",
      "poi_latitude": "40.0508556",
      "poi_longitude": "-83.05148109999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-451-6002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1516-7542-98dc-d73292a5235e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1516-7542-98dc-d73292a5235e",
        "storage_key": "property/6767906449166341/019d026b-1516-7542-98dc-d73292a5235e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzjbd2iNOIgRcudsnSTmMsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_d788a7f7-65ca-474e-a39b-d6563e586d58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Penzeys Spices",
      "poi_type": "Shopping & Retail",
      "poi_address": "4455 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Source for a vast selection of Penzeys brand spices, packaged individually & as gifts.",
      "poi_long_description": "Source for a vast selection of Penzeys brand spices, packaged individually & as gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a189-76cd-957c-3ae7b2286c17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a189-76cd-957c-3ae7b2286c17",
        "storage_key": "property/6767906449166341/019d026a-a189-76cd-957c-3ae7b2286c17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.penzeys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247242227132399360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penzeys-spices",
      "poi_latitude": "40.0493971",
      "poi_longitude": "-83.0501294",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 614-442-7779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2Usu06SNOIgRAP97MObOLx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_64a9f878-e926-4f28-a60d-1a318a0a8747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4530 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a155-73dc-bc75-1a9d77a677eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a155-73dc-bc75-1a9d77a677eb",
        "storage_key": "property/6767906449166341/019d026a-a155-73dc-bc75-1a9d77a677eb.webp",
        "width": 1280,
        "height": 643
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4530+kenny+rd-columbus-oh-43220/id=9540",
      "poi_directions_map_url": "https://maps.google.com/?cid=11140150633376497184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.0535723",
      "poi_longitude": "-83.0488005",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 614-326-0689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXF9xqWNOIgRIL6_XvrDmZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_86d42c08-743c-4e9d-be90-7769cf4d0394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1885 W Henderson Rd, Upper Arlington, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a15b-718a-bfe9-9b48bb98fab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a15b-718a-bfe9-9b48bb98fab5",
        "storage_key": "property/6767906449166341/019d026a-a15b-718a-bfe9-9b48bb98fab5.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/upper-arlington-oh-pharmacies/1885-west-henderson-road-upper-arlington-oh-43220/storeid=6149?WT.mc_id=LS_GOOGLE_RX_6149",
      "poi_directions_map_url": "https://maps.google.com/?cid=13408729534916846289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.0544774",
      "poi_longitude": "-83.06973699999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-451-6555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e442066f4ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e442066f4ad8",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e442066f4ad8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJexOa6oSNOIgR0eIBMnhgFbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f76ace05-6260-460e-838d-7bd458050c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "4501 Kenny Rd",
      "poi_type": "Shopping & Retail",
      "poi_address": "4501 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=755012694653103056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "4501-kenny-rd",
      "poi_latitude": "40.0503893",
      "poi_longitude": "-83.0505996",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3GPxqSNOIgR0Gu1qQtYego",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_26160382-4257-4343-8a77-badeb00a1bd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Kenny & Old Henderson Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4514 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Dosa and other southern-Indian dishes are served at this casual eatery with friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a35d-7043-a1d4-8f86c9fed2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a35d-7043-a1d4-8f86c9fed2d1",
        "storage_key": "property/6767906449166341/019d026a-a35d-7043-a1d4-8f86c9fed2d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15282174108494089007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenny--old-henderson-center",
      "poi_latitude": "40.0512732",
      "poi_longitude": "-83.04928489999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl7T4HKWNOIgRL0t2HGIwFdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3f7fb652-2ca2-4b8e-9b99-db3d6c55a7f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Staples",
      "poi_type": "Shopping & Retail",
      "poi_address": "4505 Kenny Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_long_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-aa6d-7467-aa30-4538475613aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-aa6d-7467-aa30-4538475613aa",
        "storage_key": "property/6767906449166341/019d026a-aa6d-7467-aa30-4538475613aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.staples.com/oh/columbus/4505-kenny-road?cmpid=st_ll_goo&cid=LS:RETAIL:G&utm_source=google&utm_medium=organic&utm_campaign=Google_Business_Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310723319864596583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staples",
      "poi_latitude": "40.050782",
      "poi_longitude": "-83.05075599999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 614-442-5554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJzyI6aSNOIgRZ5gJEFYwubg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_4cd42efd-2e90-41b2-b4d3-11974af54613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "805 Bethel Rd, Columbus, OH 43214, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a92e-7716-a038-f2f090b02053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a92e-7716-a038-f2f090b02053",
        "storage_key": "property/6767906449166341/019d026a-a92e-7716-a038-f2f090b02053.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8138715261472175814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "40.0603968",
      "poi_longitude": "-83.0413291",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 614-451-6821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHfjgrAGNOIgRxnYZ2GiG8nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_72643b4d-30a3-4813-98fa-12a52cd6dbb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "863 Bethel Rd, Columbus, OH 43214, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-a953-76ee-ba6d-abf176fac3e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-a953-76ee-ba6d-abf176fac3e5",
        "storage_key": "property/6767906449166341/019d026a-a953-76ee-ba6d-abf176fac3e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/oh/columbus/863-bethel-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7446370454609083213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.0616778",
      "poi_longitude": "-83.0429942",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 380-900-7899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ11KQ4ySNOIgRTTvw1HnSVmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_fc74a3b2-8e13-4387-9538-034da22afa69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3417 N High St, Columbus, OH 43214, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-aa4d-71e7-ae5d-145034296b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-aa4d-71e7-ae5d-145034296b3e",
        "storage_key": "property/6767906449166341/019d026a-aa4d-71e7-ae5d-145034296b3e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/columbus/clintonville/016/00971?cid=loc_01600971_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12397604210791905907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.0320219",
      "poi_longitude": "-83.0176145",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-263-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1516-7542-98dc-d73292a5235e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1516-7542-98dc-d73292a5235e",
        "storage_key": "property/6767906449166341/019d026b-1516-7542-98dc-d73292a5235e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWNSKzyMOIgRc3ojKlgjDaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0d1dcb2d-35b9-46c7-95fd-098d5d61f070",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Winterset Elementary School",
      "poi_type": "Education",
      "poi_address": "4776 Winterset Dr, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-af20-725e-b407-58bea0dd871c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-af20-725e-b407-58bea0dd871c",
        "storage_key": "property/6767906449166341/019d026a-af20-725e-b407-58bea0dd871c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.ccsoh.us/wintersetes",
      "poi_directions_map_url": "https://maps.google.com/?cid=934655078498760583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winterset-elementary-school",
      "poi_latitude": "40.054803",
      "poi_longitude": "-83.0568606",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 614-365-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHxnEGKKNOIgRh_duhdeP-Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_15b50984-4c4d-484d-86c6-9e48a3912663",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Ridgeview Middle School",
      "poi_type": "Education",
      "poi_address": "4241 Rudy Rd, Columbus, OH 43214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b0b2-760b-8c50-620157f38084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b0b2-760b-8c50-620157f38084",
        "storage_key": "property/6767906449166341/019d026a-b0b2-760b-8c50-620157f38084.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ccsoh.us/RidgeviewMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=15102675470808218601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgeview-middle-school",
      "poi_latitude": "40.0461031",
      "poi_longitude": "-83.03900689999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-365-5506",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAz91xrONOIgR6XuHw1J7l9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9a3b1adb-4703-4036-9877-2ae92990e02f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Centennial High School",
      "poi_type": "Education",
      "poi_address": "1441 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b204-74b7-b11d-5916f4daa512.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b204-74b7-b11d-5916f4daa512",
        "storage_key": "property/6767906449166341/019d026a-b204-74b7-b11d-5916f4daa512.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccsoh.us/centennialhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=17262192557336386162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-high-school",
      "poi_latitude": "40.06204779999999",
      "poi_longitude": "-83.0583496",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-365-5491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtwVtOnWNOIgRclptAKygj-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1eb9cc85-5f9e-4d9b-bd8b-e6323ba77361",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Wellington School",
      "poi_type": "Education",
      "poi_address": "3650 Reed Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b0e2-7285-97c7-b05741847cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b0e2-7285-97c7-b05741847cfd",
        "storage_key": "property/6767906449166341/019d026a-b0e2-7285-97c7-b05741847cfd.webp",
        "width": 1110,
        "height": 623
      },
      "poi_business_url": "https://www.wellington.org/?utm_source=local-listings&utm_medium=organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=5921990082748561580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellington-school",
      "poi_latitude": "40.0313006",
      "poi_longitude": "-83.0642098",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-457-7883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZe14QO-NOIgRrDidrZoiL1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5da77069-1ff5-44d5-986d-bbcc3bea49e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "St Andrew School",
      "poi_type": "Education",
      "poi_address": "4081 Reed Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b901-7486-a65f-d09e6df4de43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b901-7486-a65f-d09e6df4de43",
        "storage_key": "property/6767906449166341/019d026a-b901-7486-a65f-d09e6df4de43.webp",
        "width": 845,
        "height": 1280
      },
      "poi_business_url": "http://www.standrewschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467626312874243355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-andrew-school",
      "poi_latitude": "40.0394571",
      "poi_longitude": "-83.06750900000002",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-451-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlb5iRO2NOIgRG7UiiJV5afI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5bf94906-7371-48f6-9f9b-cf1e3f0e6879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "St Timothy School",
      "poi_type": "Education",
      "poi_address": "1070 Thomas Ln, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sttimschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577812714907613530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-timothy-school",
      "poi_latitude": "40.0340057",
      "poi_longitude": "-83.04561070000001",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-451-0739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD1LZNM-NOIgRWrmt3J7wy5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c57585b7-dca0-45b9-b4f1-cc34ab278913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Bethel Road KinderCare",
      "poi_type": "Education",
      "poi_address": "2001 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b7d1-7158-85d9-34c7a89cd47d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b7d1-7158-85d9-34c7a89cd47d",
        "storage_key": "property/6767906449166341/019d026a-b7d1-7158-85d9-34c7a89cd47d.webp",
        "width": 933,
        "height": 700
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/columbus/oh/300889?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3NDI5LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=8902222426788098321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethel-road-kindercare",
      "poi_latitude": "40.063621",
      "poi_longitude": "-83.072594",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-457-0754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh_aSIHmNOIgREXE4lCEMi3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_1fc39784-1354-489c-a2c9-6ddfd323f8dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Balanced Family Academy of Upper Arlington",
      "poi_type": "Education",
      "poi_address": "5150 Reed Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Bright childcare facility offering music and yoga classes, along with nutritious meals and clean classrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b91e-7273-9c22-38c330f3c499.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b91e-7273-9c22-38c330f3c499",
        "storage_key": "property/6767906449166341/019d026a-b91e-7273-9c22-38c330f3c499.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.balancedfamilyacademy.com/upperarlington?utm_source=Google%20Business&utm_medium=Organic&utm_campaign=location_listing&utm_content=upper_arlington",
      "poi_directions_map_url": "https://maps.google.com/?cid=10618676277090649486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "balanced-family-academy-of-upper-arlington",
      "poi_latitude": "40.0631273",
      "poi_longitude": "-83.0660499",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-745-3305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3ZIAD3eNOIgRjgXbWNAdXZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5a1a0832-2188-4eff-b359-448a9ad24069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Sunshine Early Learning Center",
      "poi_type": "Education",
      "poi_address": "3750 Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sunshinelearning.center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17812564910998212568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-early-learning-center",
      "poi_latitude": "40.06136160000001",
      "poi_longitude": "-83.0919184",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-457-4085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWWO2Z2KSOIgR2M-iWmnxMvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86c30e69-ebbd-41ca-81c8-8298f736ed63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Noble Academy Columbus(K-8)",
      "poi_type": "Education",
      "poi_address": "1329 Bethel Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-b7f8-763d-be60-841f6d54488e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-b7f8-763d-be60-841f6d54488e",
        "storage_key": "property/6767906449166341/019d026a-b7f8-763d-be60-841f6d54488e.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.noblecolumbus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353645201548835917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noble-academy-columbusk-8",
      "poi_latitude": "40.0625232",
      "poi_longitude": "-83.0550238",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 614-326-0687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD0knqwuNOIgRTfyytfYaE9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ea66e9b4-f065-4b59-b26e-7d1f102ec72b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Grandview Theater and Drafthouse",
      "poi_type": "Entertainment",
      "poi_address": "1247 Grandview Ave, Grandview Heights, OH 43212, USA",
      "poi_short_description": "This 1926 single-screen theater sells beer as well as pizza, subs & pastries from local restaurants.",
      "poi_long_description": "This 1926 single-screen theater sells beer as well as pizza, subs & pastries from local restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c029-735f-91e2-020be88cf712.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c029-735f-91e2-020be88cf712",
        "storage_key": "property/6767906449166341/019d026a-c029-735f-91e2-020be88cf712.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.grandviewtheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6243478379654578229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grandview-theater-and-drafthouse",
      "poi_latitude": "39.9831747",
      "poi_longitude": "-83.0453797",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-670-4102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e03-73ea-ac9b-f82c658ece83",
        "storage_key": "property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4fJiFGOOIgRNYAkxoFKpVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3ed7ad15-3e43-4936-9c42-1ee2c0cdb78b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Phoenix Theatres Lennox Town Center 24 + IMAX with Laser",
      "poi_type": "Entertainment",
      "poi_address": "777 Kinnear Rd, Columbus, OH 43212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-bfb0-715d-bddc-cba47b1eff78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-bfb0-715d-bddc-cba47b1eff78",
        "storage_key": "property/6767906449166341/019d026a-bfb0-715d-bddc-cba47b1eff78.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.phoenixtheatres.com/theatre-tickets/x02kt-lennox-town-center-24-theatres",
      "poi_directions_map_url": "https://maps.google.com/?cid=8225967987411338689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-theatres-lennox-town-center-24--imax-with-laser",
      "poi_latitude": "39.99604799999999",
      "poi_longitude": "-83.027852",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-429-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e03-73ea-ac9b-f82c658ece83",
        "storage_key": "property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp5gfyoyOOIgRwUVjL02CKHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0277c20b-acc1-48d0-8f8a-1d289042eeba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Marcus Crosswoods Cinema",
      "poi_type": "Entertainment",
      "poi_address": "200 Hutchinson Ave, Columbus, OH 43235, USA",
      "poi_short_description": "Theater chain for mainstream films; most offer enhanced picture & sound & expanded dining options.",
      "poi_long_description": "Theater chain for mainstream films; most offer enhanced picture & sound & expanded dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c25a-71ee-996e-191574c1bb1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c25a-71ee-996e-191574c1bb1c",
        "storage_key": "property/6767906449166341/019d026a-c25a-71ee-996e-191574c1bb1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marcustheatres.com/theatre-locations/crosswoods-cinema-columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=3623679347292034717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcus-crosswoods-cinema",
      "poi_latitude": "40.11492459999999",
      "poi_longitude": "-83.00968519999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-436-9818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e03-73ea-ac9b-f82c658ece83",
        "storage_key": "property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_EbTcHzOIgRndZC0yrlSTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_58be5cc1-944f-4a8a-841a-f5806d186991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Cinemark Polaris 18 and XD",
      "poi_type": "Entertainment",
      "poi_address": "1071 Gemini Pl, Columbus, OH 43240, USA",
      "poi_short_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_long_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c231-76bb-8071-5f0df90ee609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c231-76bb-8071-5f0df90ee609",
        "storage_key": "property/6767906449166341/019d026a-c231-76bb-8071-5f0df90ee609.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.cinemark.com/theatres/oh-columbus/cinemark-polaris-18-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NjAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10527769628804056949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-polaris-18-and-xd",
      "poi_latitude": "40.1466922",
      "poi_longitude": "-82.9860601",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-781-8228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e03-73ea-ac9b-f82c658ece83",
        "storage_key": "property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeqEa3r0OIgRdQcD6rImGpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0a2ddc55-516e-4dde-9dbf-4b0e08b83a62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Gateway Film Center",
      "poi_type": "Entertainment",
      "poi_address": "1550 N High St, Columbus, OH 43201, USA",
      "poi_short_description": "Lively, modern space for a variety of movies & film-related events, plus an undersea-themed bar.",
      "poi_long_description": "Lively, modern space for a variety of movies & film-related events, plus an undersea-themed bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c6f2-70fa-86fc-37b860eb015e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c6f2-70fa-86fc-37b860eb015e",
        "storage_key": "property/6767906449166341/019d026a-c6f2-70fa-86fc-37b860eb015e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gatewayfilmcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7386484194729862355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-film-center",
      "poi_latitude": "39.9940068",
      "poi_longitude": "-83.0063519",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-259-7182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e03-73ea-ac9b-f82c658ece83",
        "storage_key": "property/6767906449166341/019d026b-1e03-73ea-ac9b-f82c658ece83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJLV0mpMeOOIgR0yTpZT0QgmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_20195492-e6c9-44e5-bd67-9542fadc7a14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Wexner Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "1871 N High St, Columbus, OH 43210, USA",
      "poi_short_description": "Modern venue at OSU featuring contemporary art exhibitions, film screenings & performances.",
      "poi_long_description": "Modern venue at OSU featuring contemporary art exhibitions, film screenings & performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c743-757e-9432-cc4a320924a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c743-757e-9432-cc4a320924a9",
        "storage_key": "property/6767906449166341/019d026a-c743-757e-9432-cc4a320924a9.webp",
        "width": 700,
        "height": 400
      },
      "poi_business_url": "http://www.wexarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10152365146502581822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wexner-center-for-the-arts",
      "poi_latitude": "40.0002119",
      "poi_longitude": "-83.0093697",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-292-3535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_4UXLmOOIgRPs5Xq09y5Iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b2c1a77c-00cf-4104-ab40-10c1d57d9d34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Center of Science and Industry (COSI)",
      "poi_type": "Entertainment",
      "poi_address": "333 W Broad St, Columbus, OH 43215, USA",
      "poi_short_description": "This large educational science center offers interactive exhibits, working labs & planetarium shows.",
      "poi_long_description": "This large educational science center offers interactive exhibits, working labs & planetarium shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c8c4-71d0-bcdb-9de0c4022316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c8c4-71d0-bcdb-9de0c4022316",
        "storage_key": "property/6767906449166341/019d026a-c8c4-71d0-bcdb-9de0c4022316.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cosi.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3400745502878202500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-of-science-and-industry-cosi",
      "poi_latitude": "39.9598362",
      "poi_longitude": "-83.0070197",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-228-2674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d15be11683a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d15be11683a4",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d15be11683a4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5El7juPOIgRhPqPVgTgMS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_33be1951-ad36-4ab2-8c2b-17a6dd4ffba3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Columbus Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "480 E Broad St, Columbus, OH 43215, USA",
      "poi_short_description": "Varied permanent & traveling art collections plus an American cafe & a gift shop.",
      "poi_long_description": "Varied permanent & traveling art collections plus an American cafe & a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c906-72ed-84fe-cac7ad8847db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-c906-72ed-84fe-cac7ad8847db",
        "storage_key": "property/6767906449166341/019d026a-c906-72ed-84fe-cac7ad8847db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.columbusmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788151179204151493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbus-museum-of-art",
      "poi_latitude": "39.9642074",
      "poi_longitude": "-82.98789719999999",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-221-6801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d15be11683a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d15be11683a4",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d15be11683a4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJEfF3AdKIOIgRxcjY2XFaWb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f70464b8-cf02-4563-9221-926e57ef9fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Ohio Theatre",
      "poi_type": "Entertainment",
      "poi_address": "39 E State St, Columbus, OH 43215, USA",
      "poi_short_description": "Celebrated theater with ornate, Spanish-Baroque architecture features a wide range of performances.",
      "poi_long_description": "Celebrated theater with ornate, Spanish-Baroque architecture features a wide range of performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-cefa-77fa-98ae-e4b93f41815b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-cefa-77fa-98ae-e4b93f41815b",
        "storage_key": "property/6767906449166341/019d026a-cefa-77fa-98ae-e4b93f41815b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.capa.com/venues/ohio-theatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=6474509647117041413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohio-theatre",
      "poi_latitude": "39.9601774",
      "poi_longitude": "-82.99906899999999",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-469-0939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUEBUDGPOIgRBT9AezgU2lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a6619ec8-bfcc-4fd6-9379-9765fb59e528",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Palace Theatre",
      "poi_type": "Entertainment",
      "poi_address": "34 W Broad St, Columbus, OH 43215, USA",
      "poi_short_description": "Performance venue hosting theatrical as well as classical, dance & world music productions.",
      "poi_long_description": "Performance venue hosting theatrical as well as classical, dance & world music productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-cda0-7202-ba87-6b1f947a49a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-cda0-7202-ba87-6b1f947a49a4",
        "storage_key": "property/6767906449166341/019d026a-cda0-7202-ba87-6b1f947a49a4.webp",
        "width": 1170,
        "height": 878
      },
      "poi_business_url": "http://www.capa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11931456980898352609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palace-theatre",
      "poi_latitude": "39.9623526",
      "poi_longitude": "-83.0017092",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-469-9850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVXy-DCPOIgR4Q1Nl-gMlaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_8918dd14-e095-488f-be9a-cf5ce328b0b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "OhioHealth Riverside Methodist Hospital and Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "3535 Olentangy River Rd, Columbus, OH 43214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-cede-7224-a4c6-856b1503b5ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-cede-7224-a4c6-856b1503b5ac",
        "storage_key": "property/6767906449166341/019d026a-cede-7224-a4c6-856b1503b5ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/riverside-methodist-hospital/?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=17664156353374329527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohiohealth-riverside-methodist-hospital-and-emergency-department",
      "poi_latitude": "40.0308026",
      "poi_longitude": "-83.0345056",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-566-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e11-7739-85d3-d741bf09a2b4",
        "storage_key": "property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUR-PjOMOIgRtxrWW52wI_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_aa4746c6-6f08-4786-a287-81b1c58d920c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1885 W Henderson Rd, Upper Arlington, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-cf57-7558-97df-c9aca17b0364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-cf57-7558-97df-c9aca17b0364",
        "storage_key": "property/6767906449166341/019d026a-cf57-7558-97df-c9aca17b0364.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/oh/upperarlington/6149.html?WT.mc_id=LS_mc_google_carenav_6149",
      "poi_directions_map_url": "https://maps.google.com/?cid=2677857646595114635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "40.0544185",
      "poi_longitude": "-83.06973579999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVx-uYSNOIgRi4ZdeFepKSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_e026148b-aabf-49e9-b839-dbb661cd0d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Market District Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4747 Sawmill Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-d419-778c-afb9-71255b8523c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-d419-778c-afb9-71255b8523c6",
        "storage_key": "property/6767906449166341/019d026a-d419-778c-afb9-71255b8523c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gianteagle.com/pharmacy?utm_source=google&utm_medium=organic&utm_campaign=rx_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=14559833717404814427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-district-pharmacy",
      "poi_latitude": "40.0642212",
      "poi_longitude": "-83.0956882",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-923-0481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e442066f4ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e442066f4ad8",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e442066f4ad8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WHJJoqSOIgRW0yr6p_rDso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5e2f22b8-dc3f-442d-91d1-734f6e520f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1860 Henderson Rd, Columbus, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-d67f-70bc-86a7-0da16f78bccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-d67f-70bc-86a7-0da16f78bccd",
        "storage_key": "property/6767906449166341/019d026a-d67f-70bc-86a7-0da16f78bccd.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/oh/upper-arlington.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6533359399953871381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "40.0562133",
      "poi_longitude": "-83.0698013",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-326-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeWevOZuNOIgRFbI1UMInq1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b53a116b-387c-4956-93e3-b38717481576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "barre3",
      "poi_type": "Health and Wellness",
      "poi_address": "1735 W Lane Ave, Columbus, OH 43221, USA",
      "poi_short_description": "Clean, kind fitness center offering a range of classes focused on Pilates, ballet and yoga.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-d670-763c-9c54-b7a62d2aa266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-d670-763c-9c54-b7a62d2aa266",
        "storage_key": "property/6767906449166341/019d026a-d670-763c-9c54-b7a62d2aa266.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://barre3.com/studio-locations/columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=12067062530128118216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barre3",
      "poi_latitude": "40.0064654",
      "poi_longitude": "-83.0563796",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-429-3945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYRmO22OOIgRyIG25m_Rdqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eb1f7661-53e8-4ca6-ada4-da3942369b88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Row House Fitness Upper Arlington",
      "poi_type": "Health and Wellness",
      "poi_address": "1643 W Lane Ave, Upper Arlington, OH 43221, USA",
      "poi_short_description": "Energetic studio at Shops On Lane Avenue providing rowing-based fitness classes with weights and floor exercises as well.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-d857-74be-b045-15306deb8140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-d857-74be-b045-15306deb8140",
        "storage_key": "property/6767906449166341/019d026a-d857-74be-b045-15306deb8140.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.therowhouse.com/location/upper-arlington",
      "poi_directions_map_url": "https://maps.google.com/?cid=17382544244863872575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "row-house-fitness-upper-arlington",
      "poi_latitude": "40.0064438",
      "poi_longitude": "-83.0542823",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-928-9915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS3QEO6POIgRPy6f3-QzO_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eaacdfff-96c2-4f74-bd07-84b7326247d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "CYCLEBAR",
      "poi_type": "Health and Wellness",
      "poi_address": "1609 W Lane Ave, Upper Arlington, OH 43221, USA",
      "poi_short_description": "Indoor cycling studio featuring workouts set to music, plus friendly staff and instructors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-dd83-770a-8bf5-ed73c7895ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-dd83-770a-8bf5-ed73c7895ca9",
        "storage_key": "property/6767906449166341/019d026a-dd83-770a-8bf5-ed73c7895ca9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cyclebar.com/location/upper-arlington",
      "poi_directions_map_url": "https://maps.google.com/?cid=2705440951225862581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyclebar",
      "poi_latitude": "40.0067786",
      "poi_longitude": "-83.05344",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-321-2112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_zPQDQWPOIgRtcmcCjaoiyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7460fdf2-13c9-4f87-b536-1f30d47dafcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3096 Kingsdale Center, Upper Arlington, OH 43221, USA",
      "poi_short_description": "Clean, spacious fitness center featuring treadmill workouts, cardio, and strength-training classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-df04-710f-92e1-6f9b2048183b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-df04-710f-92e1-6f9b2048183b",
        "storage_key": "property/6767906449166341/019d026a-df04-710f-92e1-6f9b2048183b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/columbus-ohio-1140?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=16804812203416324933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "40.0204972",
      "poi_longitude": "-83.0600955",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-441-9657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1wUlDWNOIgRRYvHzamvNuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7fcc4be1-ee07-48f6-826c-ff7de08d010c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Reed Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3855 Reed Rd, Upper Arlington, OH 43220, USA",
      "poi_short_description": "City park with a playground, picnic areas, volleyball and tennis courts, and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-dfe9-7260-92e0-845155d06e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-dfe9-7260-92e0-845155d06e51",
        "storage_key": "property/6767906449166341/019d026a-dfe9-7260-92e0-845155d06e51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://upperarlingtonoh.gov/city-parks/reed-road-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=356860688291690744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reed-road-park",
      "poi_latitude": "40.0351879",
      "poi_longitude": "-83.0673853",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-583-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD53dCO6NOIgR-Hjtv-fS8wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7f3602ae-5a82-4b4c-aafc-2fdabf76edf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Thompson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4250 Woodbridge Rd, Upper Arlington, OH 43220, USA",
      "poi_short_description": "Local complex featuring athletic fields, paved trails, a playground & a hill for sledding.",
      "poi_long_description": "Local complex featuring athletic fields, paved trails, a playground & a hill for sledding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e0ab-733c-8adb-ad8e7ed628e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-e0ab-733c-8adb-ad8e7ed628e6",
        "storage_key": "property/6767906449166341/019d026a-e0ab-733c-8adb-ad8e7ed628e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436191305768116990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thompson-park",
      "poi_latitude": "40.0438114",
      "poi_longitude": "-83.0717067",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-583-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQXqaIyNOIgR_iLwXP8V9II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8803b7f9-3169-4eee-9367-fbb71147e15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Oxford Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4280 Oxford Dr, Upper Arlington, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e503-75c8-9514-9ca04f2e1d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-e503-75c8-9514-9ca04f2e1d21",
        "storage_key": "property/6767906449166341/019d026a-e503-75c8-9514-9ca04f2e1d21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://upperarlingtonoh.gov/city-parks/oxford-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=377127404611254019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-park",
      "poi_latitude": "40.041242",
      "poi_longitude": "-83.09054069999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-583-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6QxsBKSOIgRAzfrWmDTOwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7afa12d7-2856-4db2-8ef9-e475e77e7ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Wyandot Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2875 Lane Rd, Upper Arlington, OH 43220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e6bd-70db-a2f7-fe6d3217fcde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-e6bd-70db-a2f7-fe6d3217fcde",
        "storage_key": "property/6767906449166341/019d026a-e6bd-70db-a2f7-fe6d3217fcde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18304526297327120401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wyandot-park",
      "poi_latitude": "40.047493",
      "poi_longitude": "-83.09445",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYeUpW6SOIgREbD6la-9Bv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6a49ede2-4f02-4645-8d58-7108dace3934",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Northcrest Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Northcrest Park, 5095 Reed Rd, Columbus, OH 43220, USA",
      "poi_short_description": "Tennis and basketball courts in a park that also features a playground and a baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e74f-715e-aa03-69443ce91fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-e74f-715e-aa03-69443ce91fb4",
        "storage_key": "property/6767906449166341/019d026a-e74f-715e-aa03-69443ce91fb4.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "https://columbusrecparks.com/parks/northcrest-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5458981320259499744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northcrest-park",
      "poi_latitude": "40.0614902",
      "poi_longitude": "-83.0710055",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-645-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ211wfXiNOIgR4HaPfZYywks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6ab8e08-530e-4de3-8d81-e1f9432af14d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Burbank Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4780 Stonehaven Dr, Upper Arlington, OH 43220, USA",
      "poi_short_description": "Park with athletic fields, picnic tables, and a playground, plus trails for walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e9d6-7618-abcf-e1781833dfa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-e9d6-7618-abcf-e1781833dfa3",
        "storage_key": "property/6767906449166341/019d026a-e9d6-7618-abcf-e1781833dfa3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://upperarlingtonoh.gov/city-parks/burbank-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12964929354435458260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burbank-park",
      "poi_latitude": "40.0535143",
      "poi_longitude": "-83.0846187",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-583-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdeIjHmSOIgR1PQohY6u7LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d9f975e-5201-429b-8e9a-ad5b5fb9d9f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Anheuser-Busch Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4990 Olentangy River Rd, Columbus, OH 43214, USA",
      "poi_short_description": "This 57-acre park offers multiple sports fields & an indoor gym for basketball & volleyball.",
      "poi_long_description": "This 57-acre park offers multiple sports fields & an indoor gym for basketball & volleyball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-edfa-74cf-b10f-b3c3a035aa2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-edfa-74cf-b10f-b3c3a035aa2e",
        "storage_key": "property/6767906449166341/019d026a-edfa-74cf-b10f-b3c3a035aa2e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://columbusrecparks.com/facilities/sports-rentals/anheuser-busch-sports-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6865780397247177358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anheuser-busch-sports-park",
      "poi_latitude": "40.0573818",
      "poi_longitude": "-83.03210969999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-645-3366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK9volVWMOIgRjiLCE-UmSF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_408cebfd-c2f5-427e-b76e-0b80c8a398aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Chadwick Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "152 Howlett Hall 2021, Fyffe Rd, Columbus, OH 43210, USA",
      "poi_short_description": "These peaceful campus gardens showcase a variety of native & non-native plants & trees.",
      "poi_long_description": "These peaceful campus gardens showcase a variety of native & non-native plants & trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-efc1-712e-9822-09f08d03ab09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-efc1-712e-9822-09f08d03ab09",
        "storage_key": "property/6767906449166341/019d026a-efc1-712e-9822-09f08d03ab09.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://chadwickarboretum.osu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4150538625647738528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chadwick-arboretum",
      "poi_latitude": "40.0026252",
      "poi_longitude": "-83.0281234",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-688-3479",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs6fo3Y-OOIgRoH5FuOOsmTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_c48d5fc5-789c-4f88-9fdc-c942d3021955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "The Wilma H. Schiermeier Olentangy River Wetland Research Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "352 W Dodridge St, Columbus, OH 43202, USA",
      "poi_short_description": "Wetland area with university research center, trails & an observation pavilion, open to the public.",
      "poi_long_description": "Wetland area with university research center, trails & an observation pavilion, open to the public.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-eef2-712d-b07d-f059d646e7cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-eef2-712d-b07d-f059d646e7cd",
        "storage_key": "property/6767906449166341/019d026a-eef2-712d-b07d-f059d646e7cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://u.osu.edu/orwrpramsar",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916386024836252456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wilma-h-schiermeier-olentangy-river-wetland-research-park",
      "poi_latitude": "40.018717",
      "poi_longitude": "-83.0194956",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-292-9774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e0e-750a-85b8-d686e8fd4b8e",
        "storage_key": "property/6767906449166341/019d026b-1e0e-750a-85b8-d686e8fd4b8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-dy5SCMOIgRKEPX63Hw-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d694a8d-1902-4eaf-8c7b-e58ac0f58c7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Griggs Dam Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Riverside Dr &, Nottingham Rd, Upper Arlington, OH 43221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-f0c2-77c0-9215-9b613fa8d2e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-f0c2-77c0-9215-9b613fa8d2e4",
        "storage_key": "property/6767906449166341/019d026a-f0c2-77c0-9215-9b613fa8d2e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cota.com/how-to-ride/park-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12797128428584022724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "griggs-dam-park-and-ride",
      "poi_latitude": "40.0262574",
      "poi_longitude": "-83.09228279999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-228-1776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-2444-765f-9e09-0a498497df7f",
        "storage_key": "property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-YRvmBySOIgRxLLN8oCImLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_202be588-4fb0-4236-935c-0b5bc323153e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "P+R Olentangy & Bethel",
      "poi_type": "Transportation & Transit",
      "poi_address": "4990 Olentangy River Rd, Columbus, OH 43214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-f840-755b-9b2a-6bcdf4138a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-f840-755b-9b2a-6bcdf4138a53",
        "storage_key": "property/6767906449166341/019d026a-f840-755b-9b2a-6bcdf4138a53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cota.com/how-to-ride/park-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9644983191203694544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pr-olentangy--bethel",
      "poi_latitude": "40.0612968",
      "poi_longitude": "-83.0352456",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-228-1776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-2444-765f-9e09-0a498497df7f",
        "storage_key": "property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9XuzP-MOIgR0EdPcBzd2YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_53a2a330-35ca-4382-9071-11be820e578b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "COTA Macy's Kingsdale Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3051-3161 Northwest Blvd, Upper Arlington, OH 43221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8596417354961525320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cota-macys-kingsdale-park-and-ride",
      "poi_latitude": "40.0210684",
      "poi_longitude": "-83.0577741",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-2444-765f-9e09-0a498497df7f",
        "storage_key": "property/6767906449166341/019d026b-2444-765f-9e09-0a498497df7f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJUeFYduCNOIgRSBp83wmcTHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_fcd94f6e-febd-4570-9f37-20f0b5167093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Olentangy River Rd & w Lane Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Columbus, OH 43210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8591010253490355312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olentangy-river-rd--w-lane-ave",
      "poi_latitude": "40.007262",
      "poi_longitude": "-83.022953",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44MSgZqOOIgRcPwH9U5mOXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_6442cd4a-321e-475d-a642-2f7b11390b36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "COTA transit terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "25 E Rich St, Columbus, OH 43205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-f6e0-769c-88b6-35f9d831126e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-f6e0-769c-88b6-35f9d831126e",
        "storage_key": "property/6767906449166341/019d026a-f6e0-769c-88b6-35f9d831126e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12263054641903206989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cota-transit-terminal",
      "poi_latitude": "39.9573924",
      "poi_longitude": "-82.99921499999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_ZKufqPOIgRTYLYbzkfL6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_42c75416-4762-4b69-b030-c8ba19af1ff0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Central Ohio Transit Authority",
      "poi_type": "Transportation & Transit",
      "poi_address": "33 N High St, Columbus, OH 43215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-f819-75ac-bf15-cd553fe2ffd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-f819-75ac-bf15-cd553fe2ffd5",
        "storage_key": "property/6767906449166341/019d026a-f819-75ac-bf15-cd553fe2ffd5.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "http://www.cota.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387100396780055691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-ohio-transit-authority",
      "poi_latitude": "39.9630184",
      "poi_longitude": "-83.00097079999999",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-228-1776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1lzS6SPOIgRi-xwz0TTwko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b217b34a-b68f-4855-a08b-b94aab124bf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Greyhound Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "306 E Mound St, Columbus, OH 43215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-f95f-7368-848b-a86f2bd8c155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-f95f-7368-848b-a86f2bd8c155",
        "storage_key": "property/6767906449166341/019d026a-f95f-7368-848b-a86f2bd8c155.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7065201797303437054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-terminal",
      "poi_latitude": "39.9558692",
      "poi_longitude": "-82.9909014",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZXTo72ROIgR_ga5ApqjDGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_d1b4b1ba-ed79-4c42-8269-eaed79efc45f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "John Glenn Columbus International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4600 International Gateway, Columbus, OH 43219, USA",
      "poi_short_description": "This regional airport serving Central Ohio features a variety of artwork plus free WiFi.",
      "poi_long_description": "This regional airport serving Central Ohio features a variety of artwork plus free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-fda2-7658-9f72-bbe539111033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026a-fda2-7658-9f72-bbe539111033",
        "storage_key": "property/6767906449166341/019d026a-fda2-7658-9f72-bbe539111033.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://flycolumbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11564402479413093569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-glenn-columbus-international-airport",
      "poi_latitude": "39.9999399",
      "poi_longitude": "-82.8871767",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 614-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-2446-731b-9c53-7fd5c90a9f36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-2446-731b-9c53-7fd5c90a9f36",
        "storage_key": "property/6767906449166341/019d026b-2446-731b-9c53-7fd5c90a9f36.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ486JNBFiOIgRwWQQwcgCfaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ecab26d6-ecb3-4100-9c51-0a7599760f67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Mount Carmel St. Ann's",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 S Cleveland Ave, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-006f-73fb-a287-e4e154d91143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-006f-73fb-a287-e4e154d91143",
        "storage_key": "property/6767906449166341/019d026b-006f-73fb-a287-e4e154d91143.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mountcarmelhealth.com/location/mount-carmel-st-ann-s",
      "poi_directions_map_url": "https://maps.google.com/?cid=4415134141338069089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-carmel-st-anns",
      "poi_latitude": "40.1147248",
      "poi_longitude": "-82.94613199999999",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 380-898-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e11-7739-85d3-d741bf09a2b4",
        "storage_key": "property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3jOYh_1OIgRYagn8hu1RT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_27d3f032-4fbd-4e89-a492-3d477e549a2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Otterbein University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 S Grove St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-009a-774a-8524-e6cd327109cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-009a-774a-8524-e6cd327109cf",
        "storage_key": "property/6767906449166341/019d026b-009a-774a-8524-e6cd327109cf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.otterbein.edu/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12768663309059927298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "otterbein-university",
      "poi_latitude": "40.1268746",
      "poi_longitude": "-82.9371852",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 614-890-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMVjn7Q_1OIgRAq0U2aBnM7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_75a8e268-d011-438d-bc78-5d2b29c7f135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Polaris Fashion Place",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Polaris Pkwy, Columbus, OH 43240, USA",
      "poi_short_description": "Chain retailers & specialty shops in a modern mall with kiddie events, play areas & a food court.",
      "poi_long_description": "Chain retailers & specialty shops in a modern mall with kiddie events, play areas & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-00f5-77bc-a897-49b85b426258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-00f5-77bc-a897-49b85b426258",
        "storage_key": "property/6767906449166341/019d026b-00f5-77bc-a897-49b85b426258.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://polarisfashionplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12245776793403126775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polaris-fashion-place",
      "poi_latitude": "40.14562420000001",
      "poi_longitude": "-82.98205759999999",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 614-846-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKQyAkEH1OIgR9_OD2Ry98ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_07291a66-0989-459d-9bb1-e89c188e960d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1900 Ikea Wy, Columbus, OH 43240, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-0491-70a9-ae14-2bcbb57d9581.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-0491-70a9-ae14-2bcbb57d9581",
        "storage_key": "property/6767906449166341/019d026b-0491-70a9-ae14-2bcbb57d9581.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/columbus/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=6088231482907053057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "40.150436",
      "poi_longitude": "-82.96705810000002",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191e-7663-9001-e845b23de520",
        "storage_key": "property/6767906449166341/019d026b-191e-7663-9001-e845b23de520.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqbJk80P0OIgRAUwG4Ua-fVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_7462e1e6-4ed4-4aee-a41b-2dd146433afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Topgolf Columbus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Ikea Wy, Columbus, OH 43240, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-05a4-7234-b78b-afa03b03fd35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-05a4-7234-b78b-afa03b03fd35",
        "storage_key": "property/6767906449166341/019d026b-05a4-7234-b78b-afa03b03fd35.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/columbus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12607087257987140669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-columbus",
      "poi_latitude": "40.1500953",
      "poi_longitude": "-82.9639854",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-317-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1522-701f-9c4d-e63bec30d9d2",
        "storage_key": "property/6767906449166341/019d026b-1522-701f-9c4d-e63bec30d9d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89GzoEX0OIgRPUyt4BBf9a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0e41d173-d908-4798-b105-332b8ae95f56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Cardinal Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7000 Cardinal Pl, Dublin, OH 43017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-08ec-71fa-8cd2-f45c6521c337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-08ec-71fa-8cd2-f45c6521c337",
        "storage_key": "property/6767906449166341/019d026b-08ec-71fa-8cd2-f45c6521c337.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "https://www.cardinalhealth.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10794386015104766114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cardinal-health",
      "poi_latitude": "40.1090905",
      "poi_longitude": "-83.1208991",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 614-757-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxSVLWvtOIgRopDDvuNczZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_78703531-e1ec-4066-b9b6-9818593c9c15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "OhioHealth Dublin Methodist Hospital and Emergency Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7500 Hospital Dr, Dublin, OH 43016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-08ea-70cb-84fe-315d97e0e8b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-08ea-70cb-84fe-315d97e0e8b1",
        "storage_key": "property/6767906449166341/019d026b-08ea-70cb-84fe-315d97e0e8b1.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/dublin-methodist-hospital/?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=15620411900195662027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohiohealth-dublin-methodist-hospital-and-emergency-department",
      "poi_latitude": "40.1013826",
      "poi_longitude": "-83.165848",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-544-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e11-7739-85d3-d741bf09a2b4",
        "storage_key": "property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbg4HFaTOIgRy2hy3NzZxtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a4941b90-4c03-42bd-8707-dba5b806c740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Mount Carmel East",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6001 E Broad St, Columbus, OH 43213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-0af7-724b-b174-487fcf867682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-0af7-724b-b174-487fcf867682",
        "storage_key": "property/6767906449166341/019d026b-0af7-724b-b174-487fcf867682.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mountcarmelhealth.com/location/mount-carmel-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097889661284888292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-carmel-east",
      "poi_latitude": "39.9771598",
      "poi_longitude": "-82.84446419999999",
      "poi_miles_from_property": "15.3",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 614-234-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1e11-7739-85d3-d741bf09a2b4",
        "storage_key": "property/6767906449166341/019d026b-1e11-7739-85d3-d741bf09a2b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95Xp2ZdjOIgR5K4xE757YXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_dd225145-d6fd-4468-a57b-a79d9d51a691",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "The Ohio State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "281 W Lane Ave, Columbus, OH 43210, USA",
      "poi_short_description": "Huge public research school known for its leafy campus & sports & healthcare programs.",
      "poi_long_description": "Huge public research school known for its leafy campus & sports & healthcare programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-0d4e-740f-8c0a-14d2b9ba4d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-0d4e-740f-8c0a-14d2b9ba4d07",
        "storage_key": "property/6767906449166341/019d026b-0d4e-740f-8c0a-14d2b9ba4d07.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.osu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12334471008891602831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ohio-state-university",
      "poi_latitude": "40.0060889",
      "poi_longitude": "-83.0282624",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-292-6446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-1976-730f-a9f6-344c2bea9ad5",
        "storage_key": "property/6767906449166341/019d026b-1976-730f-a9f6-344c2bea9ad5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6fo3Y-OOIgRj4dWIQjYLKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7381b26e-5de6-4b54-bbe5-f1a475bc506d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "poi_name": "Nationwide Insurance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Nationwide Plaza, W Nationwide Blvd, Columbus, OH 43215, USA",
      "poi_short_description": "Insurance agency located within One Nationwide Plaza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-0f82-75f9-b250-5e528925c207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026b-0f82-75f9-b250-5e528925c207",
        "storage_key": "property/6767906449166341/019d026b-0f82-75f9-b250-5e528925c207.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nationwide.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2149799481474544740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nationwide-insurance",
      "poi_latitude": "39.9681139",
      "poi_longitude": "-83.0025501",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-882-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-191f-7030-afd8-78161cab7a37",
        "storage_key": "property/6767906449166341/019d026b-191f-7030-afd8-78161cab7a37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xufcS-POIgRZPSb_zyf1R0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3276ef9e92f4348f8c07cbbb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_be6308e4d5e4f59c3cc660c7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5515ec54393654ddc4ba5021",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e5378112b72a23069ed9c69b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ca43f3ac02d029bf2ca888b1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_efdc53e5cbd1b21af362231a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_02b2e354106016e444eb68fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "rating": "5",
      "name": "Eric Milner",
      "text": "I can't say enough good things about James the director of maintenance here. He's always fixes things quickly without sacrificing quality and is willing to explain what he's doing and the reasoning behind it. He's always polite and a pleasure to be around. Thanks for all that you do for the residents here, The Reserves at Arlington is lucky to have such a qualified maintenance worker on staff.",
      "date": "2025-09-03",
      "title": "false"
    },
    {
      "id": "ec_253ba1ab111e863c2790ec19",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "rating": "5",
      "name": "Jordan",
      "text": "Bree and Taylor were so helpful with helping me get approved for my apartment. They did everything they could to make sure I was taken care of and accommodated for. Thank you ladies:)",
      "date": "2025-11-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_91c689e4-8983-4706-9611-df2e8f88b434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fa593-b453-76a9-907a-3eed60daeb1c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa593-b453-76a9-907a-3eed60daeb1c",
        "storage_key": "property/6767906449166341/019fa593-b453-76a9-907a-3eed60daeb1c.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " 360 Tours",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6a431111cabeed25c9796127&sourceId=1001"
    },
    {
      "id": "custom_e5163eed-3e2e-40ca-97e8-10f4073ca8fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-bebb-74bd-9e59-5ae4ab84dbd8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with sofa, coffee table, desk, chair, and shelves.",
        "public_id": "019d026b-bebb-74bd-9e59-5ae4ab84dbd8",
        "storage_key": "property/6767906449166341/019d026b-bebb-74bd-9e59-5ae4ab84dbd8.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR, 1BA - 708 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GaqxE87h9Cj"
    },
    {
      "id": "custom_844d7490-6bd2-469a-99f6-75376f157b39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-4dec-73ca-ba93-dedae61c1af7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with two sofas and a breakfast bar leading to the dining area.",
        "public_id": "019d026c-4dec-73ca-ba93-dedae61c1af7",
        "storage_key": "property/6767906449166341/019d026c-4dec-73ca-ba93-dedae61c1af7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 1078 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sHW8mMvux7i"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_4530eea78240e52cc83cd4b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429126",
      "name": "Admin Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_315822fd236cbd4adc4f5a90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429127",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_669fdc4a0bef64405a5d4749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429128",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2793b5b72e39ad0dce6159d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429130",
      "name": "Pest Control",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_13fbc8f243e393ed9e9c679c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429131",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_30f7391526ff2c0fff0d27ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429133",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8efbb0f552bf44097b3e8d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429134",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b28eb248ab1037c3ad038fd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429136",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_50a8a63739cedb82b87e6fef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429139",
      "name": "Trash Service",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c56f7f357135d30142149ed1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "429143",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_950835ca761f8ad4eb439fb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "564948",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_658240e9d9c32564e3158680",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "564950",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f93073ac659ceaf2e4c0a197",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "564953",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3ea97306ff5dda6131b9c61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "564954",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9e53bfe104f433075c06ccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "835192",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_886d7a7f4a165ea08f1b7fd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "835196",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d640c0f0af7c95ec8f3dd91c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "835198",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_56b63297129137d91ec0f36d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "835211",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_427d81a7a0a02888dac1f9e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "engrain",
      "external_id": "945455",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a287d-0dcb-73d1-85d9-ca517fcdd782",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-reserves-at-arlington-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341"
    },
    {
      "lead_collector_id": "019c3043-9075-70bf-b26f-3c152271af01",
      "lead_source": "FACEBOOK_ADS",
      "name": "springhouse-townhomes",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341"
    },
    {
      "lead_collector_id": "019c3043-90e1-702b-a40e-c8ec5c25d1f3",
      "lead_source": "LANDING_PAGE",
      "name": "springhouse-townhomes",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-columbus-oh-433",
      "search_query": "pet friendly apartments Columbus OH",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Columbus, OH",
      "h2_subtitle": "Discover the ideal pet friendly apartments in Columbus, OH. At Reserves at Arlington, enjoy a welcoming community for both you and your furry friends.",
      "page_copy": "Looking for a home where both you and your pets are welcome? Reserves at Arlington offers pet friendly apartments in Columbus, OH, with spacious one and two-bedroom floor plans. Nestled in the vibrant Northwest neighborhood, you'll appreciate scenic walking trails perfect for daily adventures with your pets. Our community ensures that both you and your pets have everything you need for a comfortable living experience.\n\nAt Reserves at Arlington, you’ll find modern amenities tailored for a pet-centric lifestyle. Our upgraded kitchens enhance your cooking experience, while courtyard views offer a serene backdrop right outside your door. With pet-friendly features, our community ensures all pet lovers feel at home. Experience the joy of living in a place that welcomes every member of your family—schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Columbus, OH",
      "seo_description": "Welcome pets at Reserves at Arlington, Columbus, OH. Enjoy spacious layouts and trails. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-with-high-speed-internet-columbus-874",
      "search_query": "apartments with high-speed internet in Columbus",
      "category": "Amenity",
      "h1_title": "Apartments with High-Speed Internet in Columbus",
      "h2_subtitle": "Explore Columbus apartments with high-speed internet. Reserves at Arlington offers seamless connectivity for modern lifestyles.",
      "page_copy": "In the digital age, high-speed internet is a crucial amenity for any apartment. At Reserves at Arlington, located in Columbus, we understand the importance of connectivity. Our community offers apartments equipped with high-speed internet, ensuring you stay connected whether working from home or streaming your favorite shows. With our spacious one and two-bedroom floor plans, you can enjoy the perfect blend of comfort and technology.\n\nBeyond online connectivity, Reserves at Arlington provides a host of modern amenities designed to enhance your living experience. From scenic courtyard views to inviting grilling stations, you’ll find everything you need for both productivity and relaxation. The community is set in the picturesque Northwest neighborhood, offering a harmonious balance of tranquility and city access. Experience the benefits of an internet-friendly lifestyle with us—book your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with High-Speed Internet in Columbus",
      "seo_description": "Stay connected with high-speed internet at Reserves at Arlington, Columbus. Perfect for work and leisure. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-renovated-kitchens-northwest-columbus-285",
      "search_query": "apartments with renovated kitchens Northwest Columbus",
      "category": "Amenity",
      "h1_title": "Apartments with Renovated Kitchens in NW Columbus",
      "h2_subtitle": "Discover apartments with renovated kitchens in Northwest Columbus. Reserves at Arlington offers stylish, modern living spaces for everyone.",
      "page_copy": "Step into modern living at Reserves at Arlington, where our apartments boast beautifully renovated kitchens to inspire your culinary adventures. Situated in Northwest Columbus, this community offers residents both style and functionality with its upgraded kitchen features. Whether you're a gourmet chef or a casual cook, you'll appreciate the spacious layouts and high-quality finishes that make meal preparation a delightful experience.\n\nIn addition to chic, renovated kitchens, Reserves at Arlington offers an array of contemporary amenities designed to complement your lifestyle. Enjoy the serene courtyard views or gather at our community grilling stations for a barbecue evening. Located in the thriving Northwest neighborhood, our community combines urban convenience with peaceful living. Discover the joys of stylish apartment living—schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Renovated Kitchens in NW Columbus",
      "seo_description": "Enjoy renovated kitchens at Reserves at Arlington in Northwest Columbus. Modern and stylish living awaits! Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "hot-tub-apartment-columbus-oh-543",
      "search_query": "hot tub apartment Columbus OH",
      "category": "Amenity",
      "h1_title": "Hot Tub Apartments in Columbus, OH",
      "h2_subtitle": "Relax in a hot tub apartment in Columbus, OH. Experience the luxury amenities at Reserves at Arlington today.",
      "page_copy": "Experience comfort and luxury at Reserves at Arlington, where our apartments provide residents with access to a relaxing hot tub in Columbus, OH. After a long day, unwind in this soothing amenity, perfect for melting away stress and rejuvenating your senses. Nestled in the Northwest neighborhood, our community combines this luxurious feature with a variety of modern amenities to enrich your living experience.\n\nBeyond the bliss of our hot tubs, Reserves at Arlington offers residents spacious one and two-bedroom floor plans, each designed with your comfort in mind. Enjoy inviting community features, such as scenic walking trails and convenient grilling stations. Whether you're seeking relaxation or recreation, our community meets all your needs. Discover a residential oasis where leisure meets convenience—schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hot Tub Apartments in Columbus, OH",
      "seo_description": "Relax in a hot tub at Reserves at Arlington, Columbus, OH. Enjoy luxury amenities for stress-free living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "columbus-oh-apartments-dedicated-parking-714",
      "search_query": "Columbus OH apartments with dedicated parking",
      "category": "Amenity",
      "h1_title": "Columbus OH Apartments with Dedicated Parking",
      "h2_subtitle": "Find Columbus OH apartments featuring dedicated parking. Reserves at Arlington ensures convenience for your lifestyle.",
      "page_copy": "Secure your comfortable living experience at Reserves at Arlington, where dedicated parking is a top-priority amenity in our Columbus, OH apartments. Enjoy the convenience of having your own parking space, making daily commutes and errands hassle-free. Nestled in the desirable Northwest neighborhood, our community combines accessibility with tranquility, ensuring you always have a place to park upon returning home.\n\nIn addition to dedicated parking, Reserves at Arlington offers a wide range of amenities that enhance resident satisfaction. Spacious one and two-bedroom floor plans feature upgraded kitchens and high-speed internet access, while community hotspots like scenic walking trails and grilling stations invite relaxation and socializing. Experience the convenience and comfort of resplendent living with us—schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbus OH Apartments with Dedicated Parking",
      "seo_description": "Enjoy dedicated parking at Reserves at Arlington in Columbus, OH. Effortless convenience for an easy lifestyle. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-northwest-columbus-55",
      "search_query": "one bedroom apartments in Northwest Columbus",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northwest Columbus",
      "h2_subtitle": "Explore one bedroom apartments in Northwest Columbus at Reserves at Arlington. Find your ideal living space today.",
      "page_copy": "Discover the perfect one bedroom apartment at Reserves at Arlington, located in the vibrant Northwest Columbus area. Our thoughtfully designed floor plans offer the ideal blend of space and comfort, making it easy to settle into your new home. These well-appointed apartments are equipped with upgraded kitchens and feature essential amenities that cater to modern living.\n\nReserves at Arlington doesn't just stop at providing quality one-bedroom living spaces. Enjoy a community with facilities that include a relaxing hot tub and beautiful walking trails. Whether you're enjoying the peaceful courtyard views or utilizing our high-speed internet availability, you'll find everything you need here. Experience the balance of comfort and convenience—schedule a tour today to see how these one bedroom apartments can become your perfect home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Northwest Columbus",
      "seo_description": "Discover one bedroom apartments at Reserves at Arlington in Northwest Columbus. Enjoy modern living spaces and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-franklin-county-604",
      "search_query": "two bedroom apartments in Franklin County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Franklin County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Franklin County at Reserves at Arlington. Perfect for all lifestyles.",
      "page_copy": "At Reserves at Arlington, find the ideal two bedroom apartments nestled in the heart of Franklin County. Perfect for families, roommates, or anyone seeking extra space, these apartments offer both comfort and convenience. Each unit features upgraded kitchens and carefully crafted layouts designed to provide ample living and storage space.\n\nLiving at Reserves at Arlington means enjoying more than just a spacious home. Our vibrant community is equipped with amenities designed to enhance your lifestyle, like a community hot tub, scenic walking trails, and grilling stations. Located in the desirable Northwest neighborhood of Columbus, you're close to both nature and city conveniences. Experience the perfect balance—come take a tour of our two bedroom apartments in Franklin County today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Franklin County",
      "seo_description": "Spacious two bedroom apartments at Reserves at Arlington in Franklin County. Perfect blend of comfort and convenience. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-near-winterset-elementary-columbus-796",
      "search_query": "apartments near winterset elementary school columbus",
      "category": "School",
      "h1_title": "Apartments Near Winterset Elementary School",
      "h2_subtitle": "Find the ideal apartments near Winterset Elementary School in Columbus at Reserves at Arlington. Perfect for families seeking convenience and quality education.",
      "page_copy": "Located close to Winterset Elementary School, Reserves at Arlington offers the ideal setting for families looking for convenient apartments in Columbus. Our community provides the perfect balance of comfort and location, with scenic walking trails and community amenities like grilling stations that are great for family outings and gatherings.\n\nOur one and two-bedroom apartments cater to various family sizes and needs, featuring upgraded kitchens and ample living spaces. Reserves at Arlington’s proximity to Winterset Elementary ensures that school runs are hassle-free for busy parents. This pet-friendly community in the Northwest neighborhood adds extra convenience for families, with reliable high-speed internet and community spaces designed for relaxation and recreation. Discover family-friendly living today by scheduling a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Winterset Elementary School",
      "seo_description": "Reserves at Arlington offers family-friendly apartments near Winterset Elementary in Columbus. Enjoy comfort and a prime location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-close-to-ridgeview-middle-northwest-925",
      "search_query": "apartments close to ridgeview middle school northwest",
      "category": "School",
      "h1_title": "Apartments Close to Ridgeview Middle School",
      "h2_subtitle": "Explore quality apartments close to Ridgeview Middle School in Northwest Columbus at Reserves at Arlington. Perfect for families and students alike.",
      "page_copy": "Reserves at Arlington provides an excellent living experience with apartments conveniently close to Ridgeview Middle School in the Northwest Columbus area. Ideal for families and individuals looking for a community-oriented environment, our one and two-bedroom apartments offer the perfect living solution. These units feature upgraded kitchens and plenty of living space, creating an inviting home.\n\nBeyond the apartment's interior, residents enjoy access to a hot tub, well-maintained walking trails, and community grilling stations. Located in a prime area, moving to Reserves at Arlington not only brings you closer to Ridgeview Middle School but also provides easy access to local amenities and recreational activities. Enjoy the unique blend of a peaceful setting and urban conveniences—schedule your tour today and see why Reserves at Arlington is the best choice for apartments near Ridgeview Middle School!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ridgeview Middle School",
      "seo_description": "Discover great apartments near Ridgeview Middle School in Northwest Columbus at Reserves at Arlington. Ideal for families. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "reserves-arlington-near-centennial-high-school-940",
      "search_query": "reserves at arlington near centennial high school",
      "category": "School",
      "h1_title": "Reserves at Arlington Near Centennial High School",
      "h2_subtitle": "Discover the Reserves at Arlington, conveniently located near Centennial High School. Ideal for families and students seeking proximity and community.",
      "page_copy": "The Reserves at Arlington offers an exceptional living experience near Centennial High School, making it an ideal choice for families and students in Columbus. Our community features one and two-bedroom apartments with modern amenities, such as upgraded kitchens and spacious living areas, perfect for day-to-day comfort and functionality.\n\nResidents enjoy a suite of community features designed to enhance lifestyle, including scenic walking trails, a communal hot tub, and inviting grilling stations. Nestled in the Northwest neighborhood, the Reserves at Arlington offer more than just proximity to Centennial High School; they're close to shopping, dining, and recreational options as well. Experience convenience and community in one beautiful setting at the Reserves at Arlington—schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reserves at Arlington Near Centennial High School",
      "seo_description": "Explore Reserves at Arlington apartments near Centennial High School in Columbus. Perfect living with great amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-by-wellington-school-franklin-county-796",
      "search_query": "apartments by wellington school franklin county",
      "category": "School",
      "h1_title": "Apartments by Wellington School, Franklin County",
      "h2_subtitle": "Find the perfect apartments by Wellington School in Franklin County at Reserves at Arlington. Ideal for families seeking a convenient and comfortable home.",
      "page_copy": "Nestled in the heart of Franklin County, the Reserves at Arlington offers exceptional apartments just moments away from Wellington School. Our community provides a wonderfully convenient living experience for families who prioritize both education and quality lifestyle. Choose between our stylish one and two-bedroom apartments, each featuring modern upgrades like spacious kitchens and single sliding door closets.\n\nThe Reserves at Arlington not only offers proximity to Wellington School but also provides a host of enjoyable community amenities, including scenic walking trails and a relaxing hot tub. Located in a serene part of the Northwest neighborhood, residents benefit from being close to shopping, dining options, and more. Experience a perfect blend of convenience and comfort—schedule your visit today at the Reserves at Arlington, the ideal home near Wellington School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Wellington School, Franklin County",
      "seo_description": "Discover Reserves at Arlington, offering comfortable apartments near Wellington School in Franklin County. Family-friendly with great amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-near-st-andrew-school-ohio-343",
      "search_query": "apartments near st andrew school in ohio",
      "category": "School",
      "h1_title": "Apartments Near St. Andrew School, Ohio",
      "h2_subtitle": "Discover spacious apartments near St. Andrew School in Ohio at Reserves at Arlington. Perfect for families seeking a prime location with great amenities.",
      "page_copy": "Experience prime living at Reserves at Arlington, where family-friendly apartments are conveniently located near St. Andrew School in Ohio. Our vibrant community offers a choice of one and two-bedroom floor plans, complete with modern features like upgraded kitchens and expansive living spaces ideal for daily life.\n\nSituated within a picturesque setting in the Northwest neighborhood, residents enjoy easy access to St. Andrew School and the wider Columbus area. Take advantage of community amenities such as scenic walking trails and a hot tub, making it easy to relax and enjoy time with family and friends. At the Reserves at Arlington, find the perfect blend of convenience, comfort, and community spirit—schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Andrew School, Ohio",
      "seo_description": "Find Reserves at Arlington, offering family-friendly apartments near St. Andrew School in Ohio with excellent amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-close-st-timothy-school-northwest-595",
      "search_query": "apartments close to st timothy school northwest",
      "category": "School",
      "h1_title": "Apartments Close to St. Timothy School, Northwest",
      "h2_subtitle": "Explore apartments close to St. Timothy School in the Northwest area at Reserves at Arlington. Perfect for families desiring a community-focused lifestyle.",
      "page_copy": "Settle into a comfortable lifestyle at Reserves at Arlington, where apartments close to St. Timothy School provide both convenience and community appeal. Located in the Northwest area of Columbus, these one and two-bedroom apartments are designed with modern living in mind, offering upgraded kitchens and ample storage solutions like single sliding door closets.\n\nThe community boasts amenities that cater to relaxation and recreation, including courtyard views, scenic walking trails, and grilling stations. Ideal for families with school-aged children, the proximity to St. Timothy School makes daily commutes a breeze. Discover the perfect blend of lifestyle and location at the Reserves at Arlington—schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Timothy School, Northwest",
      "seo_description": "Discover Reserves at Arlington offering excellent amenities near St. Timothy School in the Northwest. Family-friendly living at its best. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "rentals-by-noble-academy-columbus-k-8-469",
      "search_query": "rentals by noble academy columbus k-8",
      "category": "School",
      "h1_title": "Rentals by Noble Academy Columbus K-8",
      "h2_subtitle": "Discover rentals near Noble Academy Columbus K-8 at Reserves at Arlington. Ideal living for families with modern amenities and comfortable spaces.",
      "page_copy": "At Reserves at Arlington, find ideal rentals situated conveniently near Noble Academy Columbus K-8. Our community offers modern living with a selection of one and two-bedroom options, perfect for families seeking proximity to quality education. Experience the convenience of modern kitchens and spacious layouts designed to enhance your daily living.\n\nLocated in the peaceful Northwest neighborhood of Columbus, Reserves at Arlington provides access to excellent community features like a relaxing hot tub and scenic walking trails. Enjoy comfortable living with the ease of being near quality schooling at Noble Academy Columbus. Embrace a lifestyle that balances relaxation and practicality—schedule a visit today to explore your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Noble Academy Columbus K-8",
      "seo_description": "Explore family-friendly rentals near Noble Academy Columbus K-8 at Reserves at Arlington. Modern amenities and excellent location. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-near-ohiohealth-riverside-methodist-hospital-columbus-oh-291",
      "search_query": "apartments near OhioHealth Riverside Methodist Hospital Columbus OH",
      "category": "Hospital",
      "h1_title": "Apartments Near OhioHealth Riverside Hospital",
      "h2_subtitle": "Find convenient apartments near OhioHealth Riverside Methodist Hospital in Columbus, OH, at Reserves at Arlington. Perfect for professionals and families alike.",
      "page_copy": "Discover the convenience of living near OhioHealth Riverside Methodist Hospital with the comfortable apartments at Reserves at Arlington. Located in Columbus, OH, our community caters to both families and healthcare professionals seeking a practical and serene living environment. Choose from spacious one and two-bedroom floor plans featuring upgraded kitchens and inviting amenities.\n\nPositioned in the Northwest neighborhood, Reserves at Arlington offers easy access to the hospital and downtown Columbus. Residents can enjoy community-centric facilities such as scenic walking trails and a relaxing hot tub. Experience the perfect blend of accessibility and comfort—make Reserves at Arlington your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OhioHealth Riverside Hospital",
      "seo_description": "Explore Reserves at Arlington, offering excellent living near OhioHealth Riverside Methodist Hospital in Columbus, OH. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-near-reed-road-park-columbus-oh-322",
      "search_query": "apartments near Reed Road Park Columbus OH",
      "category": "Park",
      "h1_title": "Apartments Near Reed Road Park, Columbus OH",
      "h2_subtitle": "Explore apartments near Reed Road Park in Columbus, OH, at Reserves at Arlington. Ideal for those seeking active and scenic living options.",
      "page_copy": "Experience the vibrant lifestyle of living near Reed Road Park with our apartments at Reserves at Arlington in Columbus, OH. Perfect for active individuals and families, our community offers modern living spaces with one and two-bedroom options, all conveniently close to the park's recreational opportunities.\n\nNestled in the Northwest area, Reserves at Arlington combines the serenity of scenic walking trails with modern amenities like upgraded kitchens and high-speed internet access. Enjoy the peacefulness of courtyard views and relax at our community hot tub. With the park just a stone's throw away, embrace a balanced lifestyle of accessibility and enjoyment. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Reed Road Park, Columbus OH",
      "seo_description": "Discover Reserves at Arlington, offering vibrant living near Reed Road Park in Columbus, OH. Enjoy modern amenities and scenic beauty. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "columbus-apartments-close-to-thompson-park-198",
      "search_query": "Columbus apartments close to Thompson Park",
      "category": "Park",
      "h1_title": "Columbus Apartments Close to Thompson Park",
      "h2_subtitle": "Reserves at Arlington offers Columbus apartments close to Thompson Park. Ideal for those who love outdoor activities and modern living.",
      "page_copy": "Located in the desirable Northwest neighborhood, Reserves at Arlington provides the perfect Columbus apartments close to Thompson Park. These one and two-bedroom units are designed for comfort and modern living, featuring updated kitchens and high-speed internet availability, ideal for anyone looking to balance work and recreation easily.\n\nWith scenic walking trails and community features like a hot tub, living at Reserves at Arlington means having access to both relaxation and park-side fun. Whether you're walking your dog or enjoying a picnic, Thompson Park is conveniently near, offering endless outdoor activities. Discover the lifestyle you deserve by visiting us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbus Apartments Close to Thompson Park",
      "seo_description": "Find Reserves at Arlington, providing Columbus living with proximity to Thompson Park. Enjoy modern amenities and outdoor fun. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "residences-near-oxford-park-franklin-county-24",
      "search_query": "residences near Oxford Park in Franklin County",
      "category": "Park",
      "h1_title": "Residences Near Oxford Park, Franklin County",
      "h2_subtitle": "Discover residences near Oxford Park in Franklin County at Reserves at Arlington. Perfect for nature lovers and comfort seekers alike.",
      "page_copy": "Uncover the ideal residences near Oxford Park in Franklin County at Reserves at Arlington. Our community offers spacious one and two-bedroom apartments designed for those who appreciate both comfort and convenience. Enjoy the benefits of upgraded kitchens and a variety of modern amenities tailored to fulfill your lifestyle needs.\n\nSituated in the thriving Northwest neighborhood of Columbus, Reserves at Arlington provides easy access to Oxford Park, where outdoor enjoyment and relaxation await. Take advantage of our community features such as scenic walking trails and a communal hot tub, all while being close to the heart of Franklin County. Schedule a tour to see your future home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Oxford Park, Franklin County",
      "seo_description": "Explore Reserves at Arlington, offering residences near Oxford Park in Franklin County. Enjoy modern living with easy park access. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-by-wyandot-park-northwest-columbus-845",
      "search_query": "apartments by Wyandot Park Northwest Columbus",
      "category": "Park",
      "h1_title": "Apartments by Wyandot Park, Northwest Columbus",
      "h2_subtitle": "Find the perfect home with apartments by Wyandot Park in Northwest Columbus. Enjoy the ideal mix of comfort and convenience.",
      "page_copy": "Nestled in the heart of Northwest Columbus, Reserves at Arlington offers apartments by Wyandot Park that are ideal for those seeking comfort and convenience. Our community provides beautifully designed one and two-bedroom floor plans equipped with upgraded kitchens and a range of modern amenities.\n\nResidents can enjoy easy access to Wyandot Park, taking advantage of outdoor activities while living in a community with features like scenic walking trails and high-speed internet. Immerse yourself in a friendly neighborhood ambiance and the tranquility of courtyard views. Come and experience what makes Reserves at Arlington the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Wyandot Park, Northwest Columbus",
      "seo_description": "Explore Reserves at Arlington for apartments by Wyandot Park in Northwest Columbus. Discover comfort and convenience today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "rental-homes-near-northcrest-park-columbus-912",
      "search_query": "rental homes near Northcrest Park Columbus",
      "category": "Park",
      "h1_title": "Rental Homes Near Northcrest Park Columbus",
      "h2_subtitle": "Explore rental homes near Northcrest Park in Columbus at Reserves at Arlington. Discover modern living in a prime location.",
      "page_copy": "At Reserves at Arlington, experience the ideal blend of modern amenities and natural beauty with our rental homes near Northcrest Park, Columbus. Our community offers thoughtfully designed one and two-bedroom residences, making it a perfect choice for anyone looking to enjoy a vibrant and convenient lifestyle.\n\nLocated in the Northwest neighborhood, our rental homes provide easy access to Northcrest Park, offering ample opportunities for outdoor recreation and relaxation. With inviting community amenities like a hot tub, grilling stations, and high-speed internet access, you'll find everything you need right at home. Schedule a tour today and see why Reserves at Arlington is the place for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Northcrest Park Columbus",
      "seo_description": "Find rental homes near Northcrest Park in Columbus at Reserves at Arlington. Enjoy modern living and outdoor fun. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "columbus-apartments-near-burbank-park-656",
      "search_query": "Columbus apartments near Burbank Park",
      "category": "Park",
      "h1_title": "Columbus Apartments Near Burbank Park",
      "h2_subtitle": "Discover Columbus apartments near Burbank Park at Reserves at Arlington. The ideal mix of style and convenience awaits you.",
      "page_copy": "Welcome to Reserves at Arlington, where comfort meets convenience with our Columbus apartments near Burbank Park. Our one and two-bedroom floor plans are perfect for those seeking a sophisticated lifestyle with easy access to nature.\n\nSituated in the bustling Northwest neighborhood, our community is just a stone's throw away from Burbank Park. Enjoy modern community amenities such as high-speed internet, scenic walking trails, and a well-equipped kitchen. Discover the perfect retreat that caters to your urban lifestyle while remaining close to outdoor adventures and recreational activities. Make Reserves at Arlington your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbus Apartments Near Burbank Park",
      "seo_description": "Explore Columbus apartments near Burbank Park at Reserves at Arlington. Enjoy modern amenities and nearby park access. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "reserves-at-arlington-near-anheuser-busch-sports-park-41",
      "search_query": "reserves at Arlington near Anheuser-Busch Sports Park",
      "category": "Park",
      "h1_title": "Reserves at Arlington Near Sports Park",
      "h2_subtitle": "Experience living at Reserves at Arlington near Anheuser-Busch Sports Park. Perfect blend of comfort and activity in Columbus.",
      "page_copy": "Discover the exceptional living experience at Reserves at Arlington, conveniently located near Anheuser-Busch Sports Park. Our one and two-bedroom apartments offer everything you need for a comfortable lifestyle with upgraded kitchens and contemporary amenities.\n\nSituated in Columbus's vibrant Northwest neighborhood, our community promises both action and relaxation. Enjoy access to walking trails, a serene courtyard, and high-speed internet, all while being just minutes from the thrilling sports events at the nearby Anheuser-Busch Sports Park. Come explore Reserves at Arlington today and find your perfect home base near all the action.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reserves at Arlington Near Sports Park",
      "seo_description": "Live at Reserves at Arlington, close to Anheuser-Busch Sports Park. Perfect mix of comfort and excitement. Visit us in Columbus now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "apartments-by-chadwick-arboretum-columbus-oh-60",
      "search_query": "apartments by Chadwick Arboretum Columbus OH",
      "category": "Park",
      "h1_title": "Apartments by Chadwick Arboretum Columbus OH",
      "h2_subtitle": "Find apartments by Chadwick Arboretum in Columbus, OH at Reserves at Arlington. Enjoy nature and modern living together.",
      "page_copy": "At Reserves at Arlington, you’ll find the perfect place to call home with our apartments by Chadwick Arboretum in Columbus, OH. Our community offers one and two-bedroom floor plans, designed with comfort and modernity in mind, providing a peaceful oasis amidst urban living.\n\nMinutes from the lush greenery of Chadwick Arboretum, our location is ideal for those who appreciate nature and tranquility. Residents enjoy access to top-tier amenities like high-speed internet, inviting walking trails, and a hot tub. Experience the blend of natural beauty and contemporary conveniences at Reserves at Arlington. Visit us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Chadwick Arboretum Columbus OH",
      "seo_description": "Explore apartments by Chadwick Arboretum at Reserves at Arlington in Columbus, OH. Embrace serene living with modern conveniences. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166341",
      "source": "custom",
      "page_item_url": "columbus-oh-apartments-close-to-wilma-h-schiermeier-828",
      "search_query": "Columbus OH apartments close to Wilma H. Schiermeier Olentangy River Wetland Research Park",
      "category": "Park",
      "h1_title": "Columbus OH Apartments Near Olentangy Wetland Park",
      "h2_subtitle": "Explore Columbus OH apartments close to Wilma H. Schiermeier Olentangy River Wetland Research Park at Reserves at Arlington.",
      "page_copy": "Discover a unique living experience at Reserves at Arlington, offering Columbus OH apartments close to the Wilma H. Schiermeier Olentangy River Wetland Research Park. Our one and two-bedroom apartments are designed to provide the perfect balance of comfort and nature.\n\nNestled in the vibrant Northwest neighborhood, our community lets you experience the benefits of urban living while enjoying the tranquility of nearby wetlands. With amenities like scenic walking trails and a high-speed internet connection, residents find both relaxation and convenience. Choose Reserves at Arlington and embrace a lifestyle intertwined with nature and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a015db-4ac6-744c-b879-2c79a8fb6872",
        "storage_key": "property/6767906449166341/01a015db-4ac6-744c-b879-2c79a8fb6872.webp",
        "width": 2000,
        "height": 1335
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbus OH Apartments Near Olentangy Wetland Park",
      "seo_description": "Find Columbus OH apartments close to the Wilma H. Schiermeier Olentangy River Wetland Park at Reserves at Arlington with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5078"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976279178"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4993356"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-53HTB7CP"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://reservesatarlington.fatwin.com/api/websites/resources/1?x=L29lQWxOSk5ObWtTOWRMeitiTEhKeFltMDhGdytDSk1iNmlMNzBaa0dCRG9rZ01jc2V5VFFnVFBBRDNmYTZ1eEZtaGd0c2xvaWFKbnM0cExIUU1WUXc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52980254240"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/r5v51j3mwny"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95493904-43e6-11ef-8600-d3b45a1a7573"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95493904-43e6-11ef-8600-d3b45a1a7573/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95493904-43e6-11ef-8600-d3b45a1a7573/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImtsNlNrQmxvS0FXbjFwV25SM2JRWXc9PSIsInZhbHVlIjoiVjZrQzZaYXVqSEY5TE0vazVzVWFFQT09IiwibWFjIjoiNzlhYzRiODgzM2I3MWE5ZjViYjA5Y2JjYmE0NTllNTBmMDBjZTQwMWZmMTA0ZWRiOThkZmVkZDY1MmUzZTA3ZCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5078",
  "custom_repli_id": "9976279178",
  "custom_realpage_id": "4993356",
  "custom_google_gtm_id": "GTM-53HTB7CP",
  "custom_perq_script_url": "https://reservesatarlington.fatwin.com/api/websites/resources/1?x=L29lQWxOSk5ObWtTOWRMeitiTEhKeFltMDhGdytDSk1iNmlMNzBaa0dCRG9rZ01jc2V5VFFnVFBBRDNmYTZ1eEZtaGd0c2xvaWFKbnM0cExIUU1WUXc9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "52980254240",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/r5v51j3mwny",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95493904-43e6-11ef-8600-d3b45a1a7573",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95493904-43e6-11ef-8600-d3b45a1a7573/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95493904-43e6-11ef-8600-d3b45a1a7573/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImtsNlNrQmxvS0FXbjFwV25SM2JRWXc9PSIsInZhbHVlIjoiVjZrQzZaYXVqSEY5TE0vazVzVWFFQT09IiwibWFjIjoiNzlhYzRiODgzM2I3MWE5ZjViYjA5Y2JjYmE0NTllNTBmMDBjZTQwMWZmMTA0ZWRiOThkZmVkZDY1MmUzZTA3ZCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "e6955fbf-1fe5-49e5-b4e1-b2639a33ffea",
  "custom_audioeye_site_hash": "db1f7fa12859a7c0517f273c7c74dcdf"
};

export const generatedAt = '2026-11-02T16:59:42.266Z';
